/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { navLegStruct } from "./class/navLogReport";
import { fppProvider } from "./class/providers/fppProvider";
import { parseAeoHogeChartLine, renderAeoHogeCharts } from "./hoge-aeo";
import { opsCntrolCom } from "./com";
import { rowIdFor, ROWID_KEY_SPEC } from "../../db/rowid";
import { OPS_REG_MIGRATION_TABLES } from "../../db/registration-retag";
import { AIRCRAFT_CONTROLLER_PROCESSES } from "../../services/database/process-db-names";
import { NamedCommandOp, NamedCommandResult, isBenignBatchReject } from "../../services/database/named-command-batch";
import { HttpError } from "../../services/database/http-error";
import * as paramCache from "./param-cache";
import * as userReadCache from "../../services/database/user-read-cache";
import {
  appearanceEnum,
  availFx,
  limitsStruct,
  msgCatStruct,
  opsMissionTypeEnum,
  parameterStruct,
  perfResultsEnum,
  property,
} from "./dataStruct";

let classCom: any;

export function setCom(com: any) {
  classCom = com;
}

export function SQLifyString(inStr: string) {
  if (inStr == undefined) {
    return "";
  }
  inStr = inStr.replace("/(\r\n|\n|\r)/gm", "").replace("'", "").replace(/'/g, "").replace(/"/g, "");
  return inStr;
}

export function getSqlDate_yyyymmdd(str): Date {
  const regex = /^20[0-9}]{2}-[0-1][0-9]-[0-3][0-9]$/g;
  if (!regex.test(str)) {
    classCom.promptMessage("could not translate time yyyy-mm-dd from string: " + str, msgCatStruct.err);
    return null;
  }
  // e.g. 2021-01-12 1220

  str = str.replace(/'/g, "").replace(/"/g, "");
  const y = parseInt(str.substr(0, 4));
  const m = parseInt(str.substr(5, 2));
  const d = parseInt(str.substr(8, 2));
  return new Date(y, m - 1, d);
}

export function runCreateScripts(): string[] {
  const cstmn: string[] = [];
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS `opsctrl_flightopscontroller_flightlist` ( `flightId` TEXT NOT NULL,`flightCrewId` TEXT NOT NULL, `creationDate` INTEGER NOT NULL, `flightNumber` TEXT NOT NULL, `author` TEXT NOT NULL, `actBlocksOffTime` INTEGER NOT NULL DEFAULT 0, `actDepTime` INTEGER NOT NULL DEFAULT 0, `actArrTime` INTEGER NOT NULL DEFAULT 0, `actBlocksOnTime` INTEGER NOT NULL DEFAULT 0, `deleted` INT NOT NULL DEFAULT 0, PRIMARY KEY(`flightId`) );"
  );
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS `opsctrl_flightopscontroller_fuel` ( `Timestamp` INTEGER NOT NULL, `flightId` TEXT NOT NULL, `parameterHash` TEXT NOT NULL, `checksum` TEXT NOT NULL,`opsMissionType` INTEGER NOT NULL, `fuelOnBoardMass` INTEGER NOT NULL DEFAULT 0, `fuelOnBoardVol` INTEGER NOT NULL DEFAULT 0, `pposEndurance` INTEGER NOT NULL DEFAULT 0, `pposRange` INTEGER NOT NULL DEFAULT 0, `pposFuelOnBoardMass` INTEGER NOT NULL DEFAULT 0, `pposFuelOnBoardVol` INTEGER NOT NULL DEFAULT 0, `obsolete` integer not null, `annunciators` text,`processResultState` INTEGER NOT NULL DEFAULT 0, `processReport` text, `revision` INTEGER NOT NULL DEFAULT 0 );"
  );
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS `opsctrl_flightopscontroller_loading` ( `Timestamp` INTEGER NOT NULL, `flightId` TEXT NOT NULL, `checksum` text not null, `emptyMass` INTEGER NOT NULL, `opsMissionType` INTEGER NOT NULL, `parameters`, `obsolete` integer not null, `annunciators` text,`processResultState` INTEGER NOT NULL DEFAULT 0, `processReport` text);"
  );
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS `opsctrl_flightopscontroller_loadingelements` ( `Timestamp` INTEGER NOT NULL, `flightId` INTEGER NOT NULL, `opsMissionType` INTEGER NOT NULL, `payLoadCodeType` INTEGER NOT NULL, `designator`, `parameterHash` text NOT NULL );"
  );
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS `opsctrl_flightopscontroller_nav` ( `Timestamp` INTEGER NOT NULL, `flightId` TEXT NOT NULL, `checksum` text not null, `pposRouteTimeToDest` INTEGER NOT NULL DEFAULT 0, `pposDirectTimeToDest` INTEGER NOT NULL DEFAULT 0, `pposDirectTimeToAlternate` INTEGER NOT NULL DEFAULT 0, `pposRouteDistanceToDest` INTEGER NOT NULL DEFAULT 0, `pposDirectDistanceToDest` INTEGER NOT NULL DEFAULT 0, `pposDirectDistanceToAlternate` INTEGER NOT NULL DEFAULT 0, `pposFlightProgressRoute` INTEGER NOT NULL DEFAULT 0, `pposEstLandingTime` INTEGER NOT NULL DEFAULT 0, `pposEstRampArrival` INTEGER NOT NULL DEFAULT 0, `pposDirectHighestTerrElevation` INTEGER NOT NULL DEFAULT 0, `pposDirectLowestTerrClearance` INTEGER NOT NULL DEFAULT 0, `pposDirectDistToLowestTerrClearance` INTEGER NOT NULL DEFAULT 0, `pposRouteDistToLowestTerrClearance` INTEGER NOT NULL DEFAULT 0, `pposTerrainHazard` INTEGER NOT NULL DEFAULT 0, `pposVicinityObsHazard` INTEGER NOT NULL DEFAULT 0, `pposDirectToDestInVmc` INTEGER NOT NULL DEFAULT 0, `pposRouteToDestInVmc` INTEGER NOT NULL DEFAULT 0, `pposDirectToDestWxHazard` INTEGER NOT NULL DEFAULT 0, `pposRouteToDestWxHazard` INTEGER NOT NULL DEFAULT 0, `pposVicinityWxHazard` INTEGER NOT NULL DEFAULT 0, `directDistanceDestToAlternate` INTEGER NOT NULL DEFAULT 0, `routeDistanceDestToAlternate` INTEGER NOT NULL DEFAULT 0, `directDistanceFromOriginToDest` INTEGER NOT NULL DEFAULT 0, `routeDistanceFromOriginToDest` INTEGER NOT NULL DEFAULT 0, `directTimeDestToAlternate` INTEGER NOT NULL DEFAULT 0, `routeTimeDestToAlternate` INTEGER NOT NULL DEFAULT 0, `directTimeFromOriginToDest` INTEGER NOT NULL DEFAULT 0, `routeTimeFromOriginToDest` INTEGER NOT NULL DEFAULT 0, `routeHighestTerrElevation` INTEGER NOT NULL DEFAULT 0, `routeLowestTerrClearance` INTEGER NOT NULL DEFAULT 0, `obsolete` integer not null, `annunciators` text,`processResultState` INTEGER NOT NULL DEFAULT 0, `processReport` text not null, `revision` INTEGER NOT NULL DEFAULT 0 );"
  );
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS `opsctrl_flightopscontroller_navseg` ( `Timestamp` INTEGER NOT NULL, `flightId` TEXT NOT NULL, `sequence` integer not null, `legId` INTEGER NOT NULL, `pointPass` INTEGER NOT NULL DEFAULT 0, `actOverflyTime` INTEGER NOT NULL DEFAULT 0, `actOverflyAltAmsl` INTEGER NOT NULL DEFAULT 0, `actOverflyGroundspeed` INTEGER NOT NULL DEFAULT 0, `actFuelBurnoffAtOverfly` INTEGER NOT NULL DEFAULT 0, `actFuelRemainingAtOverfly` INTEGER NOT NULL DEFAULT 0, `actEstAlternateFuelAvail` INTEGER NOT NULL DEFAULT 0 );"
  );
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS `opsctrl_flightopscontroller_param` ( `timestamp` INTEGER NOT NULL, `parameterHash` TEXT NOT NULL,`opsMissionType` INTEGER NOT NULL, `deleted` INTEGER NOT NULL DEFAULT 0, `acknowledged` INTEGER NOT NULL DEFAULT 0, `paramTypeId` INTEGER NOT NULL, `tableSuffix` TEXT NOT NULL, `paramValString` TEXT, `paramValBlob` TEXT, `paramValJson` TEXT, `paramValGeoJson` TEXT, `paramValMarkDown` TEXT );"
  );
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS `opsctrl_flightopscontroller_perf` ( `Timestamp` INTEGER NOT NULL, `flightId` TEXT NOT NULL, `checksum` TEXT NOT NULL,`opsMissionType` INTEGER NOT NULL, `pposServiceCeiling` INTEGER NOT NULL DEFAULT 0, `pposServiceCeilingOei` INTEGER NOT NULL DEFAULT 0, `pposHeliVtolCatAWeight` INTEGER NOT NULL DEFAULT 0, `pposHeliHogeWeight` INTEGER NOT NULL DEFAULT 0, `pposHeliVtolCatAWeightLeft` INTEGER NOT NULL DEFAULT 0, `pposHeliHogeWeightLeft` INTEGER NOT NULL DEFAULT 0, `pposHeliOeiClimbGreater50ftmin` INTEGER NOT NULL DEFAULT 0, `obsolete` INTEGER NOT NULL, `annunciators` text,`processResultState` INTEGER NOT NULL DEFAULT 0, `processReport` text not null);"
  );
  cstmn.push("CREATE INDEX IF NOT EXISTS `flightId` ON `opsctrl_flightopscontroller_flightlist` ( `flightId` ASC );");
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `flightNumber` ON `opsctrl_flightopscontroller_flightlist` ( `flightNumber` ASC );"
  );
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `flightCrewId` ON `opsctrl_flightopscontroller_flightlist` ( `flightCrewId` ASC );"
  );
  cstmn.push("CREATE INDEX IF NOT EXISTS `depTime` ON `opsctrl_flightopscontroller_flightlist` ( `actDeptime` ASC );");
  cstmn.push("CREATE INDEX IF NOT EXISTS `arrTime` ON `opsctrl_flightopscontroller_flightlist` ( `actArrTime` ASC );");
  cstmn.push("CREATE INDEX IF NOT EXISTS `flightId_fuel` ON `opsctrl_flightopscontroller_fuel` ( `flightId` ASC );");
  cstmn.push("CREATE INDEX IF NOT EXISTS `flightId_fuel2` ON `opsctrl_flightopscontroller_fuel` ( `obsolete` ASC );");
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `flightId_loading` ON `opsctrl_flightopscontroller_loading` ( `flightId` ASC );"
  );
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `flightId_loading2` ON `opsctrl_flightopscontroller_loading` ( `obsolete` ASC );"
  );
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `flightId_loadingelements1` ON `opsctrl_flightopscontroller_loadingelements` ( `flightId` ASC );"
  );
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `flightId_loadingelements2` ON `opsctrl_flightopscontroller_loadingelements` ( `opsMissionType` ASC );"
  );
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `flightId_loadingelements3` ON `opsctrl_flightopscontroller_loadingelements` ( `payLoadCodeType` ASC );"
  );
  cstmn.push("CREATE INDEX IF NOT EXISTS `flightId_nav` ON `opsctrl_flightopscontroller_nav` ( `flightId` ASC );");
  cstmn.push("CREATE INDEX IF NOT EXISTS `flightId_nav2` ON `opsctrl_flightopscontroller_nav` ( `obsolete` ASC );");
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `flightId_navseg` ON `opsctrl_flightopscontroller_navseg` ( `flightId` ASC );"
  );
  cstmn.push("CREATE INDEX IF NOT EXISTS `legId_navseg` ON `opsctrl_flightopscontroller_navseg` ( `legId` ASC );");
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `pointPass_navSeg` ON `opsctrl_flightopscontroller_navseg` ( `pointPass` ASC );"
  );
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `flightId_param` ON `opsctrl_flightopscontroller_param` ( `parameterHash` ASC );"
  );
  cstmn.push("CREATE INDEX IF NOT EXISTS `deleted_param` ON `opsctrl_flightopscontroller_param` ( `deleted` ASC );");
  cstmn.push("CREATE INDEX IF NOT EXISTS `ack_param` ON `opsctrl_flightopscontroller_param` ( `acknowledged` ASC );");
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `paramType_param` ON `opsctrl_flightopscontroller_param` ( `paramTypeId` ASC ); "
  );
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `tableSuffix_param` ON `opsctrl_flightopscontroller_param` ( `tableSuffix` DESC );"
  );
  cstmn.push("CREATE INDEX IF NOT EXISTS `flightId_perf` ON `opsctrl_flightopscontroller_perf` ( `flightId` ASC );");
  cstmn.push("CREATE INDEX IF NOT EXISTS `flightId_perf2` ON `opsctrl_flightopscontroller_perf` ( `obsolete` ASC );");
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS `opsctrl_flightopscontroller_flightcrew` (`flightCrewId`TEXT NOT NULL,`crewDesignator`INTEGER NOT NULL,`pilotInCommand`TEXT NOT NULL,`missionLimits`TEXT NOT NULL,`ident`TEXT,`parameters`TEXT,`dutyFrom`INTEGER NOT NULL,`dutyTo`INTEGER NOT NULL,`created`INTEGER NOT NULL,`signature`TEXT NOT NULL,PRIMARY KEY(`flightCrewId`));"
  );
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `flightCrew` ON `opsctrl_flightopscontroller_flightcrew` (`crewDesignator`ASC,`dutyFrom`ASC,`dutyTo`ASC,`pilotInCommand`	ASC);"
  );

  // notam/met: rowId is the PRIMARY KEY (matches the server schema, the
  // db/sync-tables.ts pk='rowId', and the catalog notamInsert/metInsert
  // ON CONFLICT(rowId)). The legacy schema declared PRIMARY KEY('Timestamp'),
  // which the rowId-only conflict target could not resolve — a second flight
  // briefed in the same millisecond raised an unhandled UNIQUE(Timestamp)
  // failure that silently dropped the upsert on BOTH the catalog write path and
  // the remote-apply path (buildApplyUpsert). Fresh installs get the rowId PK
  // here (rowId column included so the PK is declarable); the redundant
  // ALTER ADD rowId / UNIQUE(rowId) in runRegistrationMigrationScripts are
  // duplicate-column / IF NOT EXISTS no-ops on a fresh install. Existing installs
  // are rebuilt off the Timestamp PK by rebuildNotamMetRowIdPkScripts().
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS 'opsctrl_flightopscontroller_notam' ('rowId' TEXT,'Timestamp'	INTEGER NOT NULL,'flightId'	TEXT NOT NULL,'checksum'    TEXT,'obsolete'	INTEGER NOT NULL,'annunciators'	TEXT,'processResultState'	INTEGER NOT NULL,'processReport'	TEXT NOT NULL,PRIMARY KEY('rowId'));"
  );
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS 'opsctrl_flightopscontroller_notam_index' ON 'opsctrl_flightopscontroller_notam' ('flightId'	ASC,'obsolete'	ASC);"
  );
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS 'opsctrl_flightopscontroller_met' ('rowId' TEXT,'Timestamp'	INTEGER NOT NULL,'flightId'	TEXT NOT NULL,'checksum'	TEXT,'obsolete'	INTEGER NOT NULL,'annunciators'	TEXT,'processResultState'	INTEGER NOT NULL,'processReport'	TEXT NOT NULL,PRIMARY KEY('rowId'));"
  );
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS 'opsctrl_flightopscontroller_met_index' ON 'opsctrl_flightopscontroller_met' ('flightId'	ASC,'obsolete'	ASC);"
  );

  // FCC TABLES FOR LOCAL DUTIES
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS `opsctrl_flightcrewcontroller_crewmemberdata` ( `Pk` INTEGER, `crewMemberId` text NOT NULL, `dutyId` INTEGER NOT NULL, `keyName` TEXT NOT NULL, `value` TEXT NOT NULL, PRIMARY KEY(`Pk`) );"
  );
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS `opsctrl_flightcrewcontroller_duties` ( `dutyId` text NOT NULL, `created` INTEGER NOT NULL, `updated` INTEGER NOT NULL, `origin` TEXT NOT NULL, `dutyStartTime` INTEGER NOT NULL, `dutyEndTime` INTEGER NOT NULL, `dutyOverlap` INTEGER NOT NULL, `aircraftRegistration` TEXT NOT NULL, `homeBaseIdent` TEXT NOT NULL, `pilotsAboard` TEXT NOT NULL, `parameters` TEXT NOT NULL, `dutyDesig` TEXT NOT NULL, `processReport` TEXT NOT NULL, PRIMARY KEY(`dutyId`) );"
  );
  cstmn.push(
    "CREATE TABLE IF NOT EXISTS `opsctrl_flightcrewcontroller_historiccrewmembers` ( `crewMemberId` text NOT NULL, `created` INTEGER NOT NULL, `name` TEXT NOT NULL, `origin` TEXT NOT NULL, `lastDutyDate` INTEGER NOT NULL, `servicedAircraft` TEXT NOT NULL, `servicedHombases` TEXT NOT NULL, PRIMARY KEY(`crewMemberId`) );"
  );
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `crewMemberData` ON `opsctrl_flightcrewcontroller_crewmemberdata` ( `crewMemberId` ASC, `dutyId` ASC, `keyName` ASC );"
  );
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `duties` ON `opsctrl_flightcrewcontroller_duties` ( `dutyId` ASC, `origin` ASC, `dutyStartTime` ASC, `dutyEndTime` ASC, `aircraftRegistration` ASC, `homeBaseIdent` ASC );"
  );
  cstmn.push(
    "CREATE INDEX IF NOT EXISTS `historicCrewMember` ON `opsctrl_flightcrewcontroller_historiccrewmembers` ( `crewMemberId` ASC, `lastDutyDate` ASC, `servicedAircraft` ASC, `servicedHombases` ASC );"
  );

  return cstmn;
}

/**
 * ROWID_KEY_SPEC (the deterministic rowId composition per opsctrl table) now
 * lives in ../../db/rowid.ts (dep-free) so the rowId backfill can consume it
 * without importing this Angular/Capacitor-coupled module. Re-exported here for
 * the existing call-sites.
 */
export { ROWID_KEY_SPEC };

/**
 * Phase A multi-device-sync migration: scoped catalog reads expect a `registrationId`
 * column on every opsctrl table and a `registration` table to resolve the current id from.
 * Mobile native is single-tenant, so we synthesize a 'legacy-device' registration; the web
 * SPA uses the real registrationId from the server-side JWT claim.
 *
 * Run on every startup, not just fresh install — existing devices need the schema upgrade.
 * Statements are idempotent: ALTER ADD COLUMN with NOT NULL DEFAULT populates every existing
 * row in the same step (no separate backfill needed); on subsequent runs ALTER fails with
 * "duplicate column name", which the caller swallows.
 */
export function runRegistrationMigrationScripts(): string[] {
  const stmts: string[] = [];
  for (const tbl of OPS_REG_MIGRATION_TABLES) {
    stmts.push(`ALTER TABLE \`${tbl}\` ADD COLUMN \`registrationId\` TEXT NOT NULL DEFAULT 'legacy-device';`);
  }
  // Peer-sync (Phase 2): the legacy local schema never stored `updatedAt` — it
  // was server-stamped only. Native client-apply needs it locally so the LWW
  // guard can compare an incoming remote op's updatedAt against the stored row
  // (and so the apply writes the version's timestamp). Existing rows seed
  // updatedAt=0 (NOT NULL DEFAULT 0) → the first remote op for any rowId wins
  // LWW and stamps the real value; local-only flights (never pushed) are never
  // targeted by a remote op, so the 0 is benign. Local-write updatedAt-stamping
  // (the push half) lands with the durable op-log in Phase 3. Same idempotent
  // ALTER pattern (duplicate-column on re-run swallowed by the caller).
  for (const tbl of OPS_REG_MIGRATION_TABLES) {
    stmts.push(`ALTER TABLE \`${tbl}\` ADD COLUMN \`updatedAt\` INTEGER NOT NULL DEFAULT 0;`);
  }
  // navseg/loadingelements gained an `obsolete` flag so the web sync path can
  // mark-then-reinsert (the server schema carries it; see efb-app-server
  // tables.ts). Native still delete-then-reinserts locally, so the column stays
  // 0 here — but the shared catalog reads now filter `obsolete = 0`, which would
  // throw `no such column` on native without this. Same idempotent ALTER
  // pattern as registrationId (duplicate-column on re-run is swallowed).
  for (const tbl of ["opsctrl_flightopscontroller_navseg", "opsctrl_flightopscontroller_loadingelements"]) {
    stmts.push(`ALTER TABLE \`${tbl}\` ADD COLUMN \`obsolete\` INTEGER NOT NULL DEFAULT 0;`);
  }
  // crewmemberdata gained a `deleted` flag (A5) so the adhoc-crew re-plan can
  // soft-delete members no longer in the duty's set via reconcileCollection (the
  // server schema carries it; see efb-app-server tables.ts). The shared crew
  // reads now filter `deleted = 0`, which would throw `no such column` on native
  // without this. Same idempotent ALTER pattern (duplicate-column on re-run
  // swallowed by the caller).
  stmts.push(
    "ALTER TABLE `opsctrl_flightcrewcontroller_crewmemberdata` ADD COLUMN `deleted` INTEGER NOT NULL DEFAULT 0;"
  );
  // fuel/nav gained a monotonic `revision` counter. Under upsert-in-place the old
  // COUNT(*) revision label collapses to 1, so the counter is now stored per row
  // (max(revision)+1 stamped on each recalc; the markdown header reads MAX). Same
  // idempotent ALTER pattern (duplicate-column on re-run swallowed by the caller).
  //
  // CUTOVER NOTE (one-time, native upgrades only): every pre-existing row is
  // seeded revision=0 by the NOT NULL DEFAULT, so the first recalc after the
  // upgrade reads MAX(revision)=0 and stamps revision=1 — even for a flight that
  // previously showed e.g. "revision 7" under the old mark-obsolete-then-insert
  // COUNT(*) label. The revision number therefore restarts at 1 at the
  // upsert-in-place model boundary; this is the intended cutover semantics, NOT a
  // data anomaly. A precise backfill is impossible here: the old version-trail
  // rows that the COUNT(*) label was derived from no longer exist after the
  // cutover, and no per-flight max is stored to seed from. The counter is
  // correctly monotonic from this point forward. The web SPA is unaffected (fresh
  // registration store, no pre-upgrade rows).
  for (const tbl of ["opsctrl_flightopscontroller_fuel", "opsctrl_flightopscontroller_nav"]) {
    stmts.push(`ALTER TABLE \`${tbl}\` ADD COLUMN \`revision\` INTEGER NOT NULL DEFAULT 0;`);
  }
  // Deterministic-rowId write model: every table in ROWID_KEY_SPEC gains a
  // nullable `rowId` column + a UNIQUE index. Nullable so the idempotent ALTER
  // (duplicate-column swallowed by the caller) upgrades existing installs in
  // place; the one-time backfill of existing rows' rowId runs separately — there
  // is no md5() in SQLite, so it is computed in TS (see backfillRowIds). A UNIQUE
  // index permits multiple NULLs, so creating it before the backfill populates
  // current rows is safe (fresh rows are all NULL → no conflict).
  for (const tbl of Object.keys(ROWID_KEY_SPEC)) {
    stmts.push(`ALTER TABLE \`${tbl}\` ADD COLUMN \`rowId\` TEXT;`);
  }
  // Signed-flight attribution (2026-08-13): each report row freezes the
  // flightcrew row (flightCrewId) in force when the calculation ran. Nullable,
  // and existing rows deliberately stay NULL — their true signature is not
  // recoverable, and backfilling from flightlist.flightCrewId would stamp the
  // CURRENT signature onto calculations made under an earlier one, which is the
  // exact misattribution this column exists to remove. NULL = unknown.
  //
  // The 6 report tables only: navseg/loadingelements inherit from their parent
  // nav/loading row, and param is flight INPUT rather than a calculation.
  for (const tbl of [
    "opsctrl_flightopscontroller_fuel",
    "opsctrl_flightopscontroller_perf",
    "opsctrl_flightopscontroller_loading",
    "opsctrl_flightopscontroller_nav",
    "opsctrl_flightopscontroller_met",
    "opsctrl_flightopscontroller_notam",
  ]) {
    stmts.push(`ALTER TABLE \`${tbl}\` ADD COLUMN \`signatureId\` TEXT;`);
  }
  // The calculation result: the figures of one version as one JSON document.
  // NULL = a version whose figures are param rows (written before this column).
  for (const tbl of [
    "opsctrl_flightopscontroller_fuel",
    "opsctrl_flightopscontroller_perf",
    "opsctrl_flightopscontroller_loading",
  ]) {
    stmts.push(`ALTER TABLE \`${tbl}\` ADD COLUMN \`resultJson\` TEXT;`);
  }
  for (const tbl of Object.keys(ROWID_KEY_SPEC)) {
    stmts.push(`CREATE UNIQUE INDEX IF NOT EXISTS \`${tbl}_rowId\` ON \`${tbl}\`(\`rowId\`);`);
  }
  // Append-only versions (2026-08-13): reads resolve the CURRENT calculation as
  // the highest Timestamp per identity group among obsolete = 0. Without these
  // the correlated MAX() scans every version of the flight.
  stmts.push(
    "CREATE INDEX IF NOT EXISTS idx_fuel_version ON opsctrl_flightopscontroller_fuel(flightId, opsMissionType, obsolete, Timestamp);"
  );
  stmts.push(
    "CREATE INDEX IF NOT EXISTS idx_loading_version ON opsctrl_flightopscontroller_loading(flightId, opsMissionType, obsolete, Timestamp);"
  );
  stmts.push(
    "CREATE INDEX IF NOT EXISTS idx_perf_version ON opsctrl_flightopscontroller_perf(flightId, opsMissionType, obsolete, Timestamp);"
  );
  stmts.push(
    "CREATE INDEX IF NOT EXISTS idx_nav_version ON opsctrl_flightopscontroller_nav(flightId, obsolete, Timestamp);"
  );
  stmts.push(
    "CREATE INDEX IF NOT EXISTS idx_met_version ON opsctrl_flightopscontroller_met(flightId, obsolete, Timestamp);"
  );
  stmts.push(
    "CREATE INDEX IF NOT EXISTS idx_notam_version ON opsctrl_flightopscontroller_notam(flightId, obsolete, Timestamp);"
  );
  // Composite (registrationId, pk) unique indexes for the sentinel-pk tables (#25).
  // duties.dutyId and crewmemberdata.rowId are per-registration sentinels (the
  // adhoc duty's '0', and the rowId hash that excludes registrationId), so the
  // shared catalog upsert SQL targets `ON CONFLICT(registrationId, <pk>)` — which
  // SQLite only resolves against a matching unique index. Native is single-tenant
  // (one registrationId), so these indexes carry the same uniqueness as the
  // single-col pk on existing data; on the shared web app-server the composite PK
  // (server schema) is what actually isolates tenants. Multiple NULL rowIds stay
  // distinct, so creating the crewmemberdata index before any backfill is safe.
  stmts.push(
    "CREATE UNIQUE INDEX IF NOT EXISTS `duties_reg_dutyId` ON `opsctrl_flightcrewcontroller_duties`(`registrationId`, `dutyId`);"
  );
  stmts.push(
    "CREATE UNIQUE INDEX IF NOT EXISTS `crewmemberdata_reg_rowId` ON `opsctrl_flightcrewcontroller_crewmemberdata`(`registrationId`, `rowId`);"
  );
  // The legacy rowId=NULL current rows are migrated by a two-step sequence run by
  // the caller AFTER this schema migration: backfillRowIds() assigns each current
  // row its concrete rowId (preserving param INPUT data in place), then
  // retireUnmigratedCurrentRowsScripts() (below) sweeps anything the backfill
  // could not claim. Order matters — the sweep must never run before the backfill
  // or it tombstones rows the backfill would have preserved.
  stmts.push(
    "CREATE TABLE IF NOT EXISTS `registration` (`id` TEXT PRIMARY KEY, `homeBaseIdent` TEXT, `displayName` TEXT, `lastSeq` INTEGER, `createdAt` INTEGER);"
  );
  stmts.push(
    "INSERT OR IGNORE INTO `registration` (`id`, `homeBaseIdent`, `displayName`, `lastSeq`, `createdAt`) VALUES ('legacy-device', '', 'Legacy Device', 0, CAST(strftime('%s', 'now') AS INTEGER) * 1000);"
  );
  // Phase 3 (durable op-log) — the native push half. `sync_oplog` is the
  // append-only outbox written on every sync write (alongside the local upsert,
  // at the namedCommand chokepoint): it survives offline + app restart, is
  // flushed oldest-first on (re)connect via APPLY, and is the local version
  // history that satisfies the audit requirement (upsert-in-place otherwise
  // overwrites prior versions; the server keeps the forever archive in
  // sync_audit). NOT a catalog entry — the append is internal to the write
  // chokepoint, so it carries no drift-mirror; its own better-sqlite3 smoke
  // covers behaviour. Each statement is a separate array element: Android
  // SQLiteDatabase.execSQL runs only the FIRST statement of a multi-stmt string.
  // IF NOT EXISTS makes the every-boot re-run idempotent (no swallowed error).
  stmts.push(
    "CREATE TABLE IF NOT EXISTS `sync_oplog` (" +
      "`localSeq` INTEGER PRIMARY KEY AUTOINCREMENT, " +
      "`tableName` TEXT NOT NULL, " +
      "`rowId` TEXT NOT NULL, " +
      "`op` TEXT NOT NULL, " +
      "`rowJson` TEXT NOT NULL, " +
      "`updatedAt` INTEGER NOT NULL, " +
      "`mutationId` TEXT NOT NULL, " +
      "`acked` INTEGER NOT NULL DEFAULT 0);"
  );
  // Drives the flush drain (`WHERE acked = 0 ORDER BY localSeq`) and the
  // retention prune (`WHERE acked = 1 AND localSeq < watermark`).
  stmts.push("CREATE INDEX IF NOT EXISTS `idx_oplog_unacked` ON `sync_oplog`(`acked`, `localSeq`);");
  return stmts;
}

/**
 * Retire sweep — the safety net for the deterministic-rowId backfill, run by the
 * caller AFTER backfillRowIds() (#23) and the schema migration. The backfill
 * assigns a concrete rowId to every current (obsolete=0 / deleted=0) row, so
 * these UPDATEs normally match nothing. They only fire for current rows the
 * backfill could not claim — a legacy duplicate that lost the per-rowId
 * collision, or a row with a NULL key column. Without the sweep such a leftover
 * rowId=NULL current row would shadow the fresh concrete-rowId row in the
 * obsolete=0 / deleted=0 reads (which take result[0] expecting exactly one live
 * row per logical key).
 *
 * MUST NOT run before the backfill: before rowIds are assigned every current row
 * is rowId=NULL, so the sweep would tombstone the whole live set — including the
 * `param` table that holds a flight's INPUT data (origin/dest/route/fuel), which
 * is exactly the data loss #23's backfill exists to prevent.
 *
 * Idempotent: post-migration current rows carry a concrete rowId, so the
 * `rowId IS NULL` scope matches nothing on re-runs; new-model writes always set
 * rowId, so they are never touched. fuel/nav keep revision=0 (the documented
 * cutover restart at 1) — revision lives outside the obsolete filter so
 * MAX(revision) still sees a swept row. The web SPA is unaffected (fresh
 * per-registration store, no pre-upgrade rows).
 */
export function retireUnmigratedCurrentRowsScripts(): string[] {
  const stmts: string[] = [];
  // obsolete-flag tables: the 1-to-1 reports + the A4 collections (navseg /
  // loadingelements, which reconcileCollection cannot address by a NULL rowId).
  const OBSOLETE_TABLES = [
    "opsctrl_flightopscontroller_nav",
    "opsctrl_flightopscontroller_met",
    "opsctrl_flightopscontroller_notam",
    "opsctrl_flightopscontroller_fuel",
    "opsctrl_flightopscontroller_perf",
    "opsctrl_flightopscontroller_loading",
    "opsctrl_flightopscontroller_navseg",
    "opsctrl_flightopscontroller_loadingelements",
  ];
  for (const tbl of OBSOLETE_TABLES) {
    stmts.push(`UPDATE \`${tbl}\` SET \`obsolete\` = 1 WHERE \`rowId\` IS NULL AND \`obsolete\` = 0;`);
  }
  // deleted-flag tables: param (flight INPUT data) + crewmemberdata (A5 adhoc crew).
  stmts.push("UPDATE `opsctrl_flightopscontroller_param` SET `deleted` = 1 WHERE `rowId` IS NULL AND `deleted` = 0;");
  stmts.push(
    "UPDATE `opsctrl_flightcrewcontroller_crewmemberdata` SET `deleted` = 1 WHERE `rowId` IS NULL AND `deleted` = 0;"
  );
  return stmts;
}

/**
 * The notam/met tables whose PRIMARY KEY must be rowId, not Timestamp. The
 * legacy local schema declared PRIMARY KEY('Timestamp'); the deterministic-rowId
 * write model + the remote-apply path both upsert ON CONFLICT(rowId), so a new
 * rowId whose Timestamp collided with an existing row raised an unhandled
 * UNIQUE(Timestamp) failure that silently dropped the write. These are the only
 * two opsctrl tables whose real PK was Timestamp rather than the pk the sync
 * layer targets.
 */
export const NOTAM_MET_ROWID_PK_TABLES = [
  "opsctrl_flightopscontroller_notam",
  "opsctrl_flightopscontroller_met",
] as const;

/**
 * One-time per-table rebuild that moves a legacy notam/met table off the
 * `Timestamp` PRIMARY KEY onto a `rowId` PRIMARY KEY (matching the server schema,
 * the catalog *Insert ON CONFLICT(rowId), and db/sync-tables.ts pk='rowId').
 *
 * Returns the SQLite table-rebuild sequence for ONE table as separate single
 * statements — the caller (database.service.ts) executes them one at a time
 * (Android `SQLiteDatabase.execSQL` runs only the first statement of a
 * multi-statement string) AND guards on the current PK so the rebuild runs only
 * while the table still has the Timestamp PK (no per-boot churn once converted).
 *
 * MUST run AFTER the rowId backfill + retire sweep: only current rows carry a
 * concrete rowId by then. The copy keeps `rowId IS NOT NULL` rows — a `rowId`
 * PRIMARY KEY cannot hold the multiple NULL-rowId obsolete history rows the
 * legacy mark-obsolete-then-insert model left behind, and those rows are never
 * read (every notam/met SELECT filters `obsolete = 0`) and were already orphaned
 * by the retire sweep, so dropping them loses nothing live. The new model has no
 * history (it upserts in place). The scratch `_new` table is dropped first so a
 * crash mid-rebuild self-heals on the next boot.
 */
export function rebuildNotamMetRowIdPkScripts(table: string): string[] {
  // `signatureId` is enumerated here because this rebuild runs AFTER
  // runRegistrationMigrationScripts has ALTERed it in (database.service.ts), and
  // a fixed column list silently drops whatever it omits. Omitting it used to
  // cost only the two inserts; since 2026-08-14 the met and notam report READS
  // select it, so the one legacy-upgrade boot that performs the rebuild would
  // throw `no such column: signatureId` on a report needing no recalculation.
  // Anything added to these two tables by the migration belongs in both lists.
  const cols =
    "rowId, Timestamp, flightId, checksum, obsolete, annunciators, processResultState, processReport, signatureId";
  return [
    `DROP TABLE IF EXISTS \`${table}_new\`;`,
    `CREATE TABLE \`${table}_new\` ('rowId' TEXT,'registrationId' TEXT NOT NULL DEFAULT 'legacy-device','updatedAt' INTEGER NOT NULL DEFAULT 0,'Timestamp' INTEGER NOT NULL,'flightId' TEXT NOT NULL,'checksum' TEXT,'obsolete' INTEGER NOT NULL,'annunciators' TEXT,'processResultState' INTEGER NOT NULL,'processReport' TEXT NOT NULL,'signatureId' TEXT,PRIMARY KEY('rowId'));`,
    `INSERT INTO \`${table}_new\` (${cols}, registrationId, updatedAt) SELECT ${cols}, registrationId, updatedAt FROM \`${table}\` WHERE \`rowId\` IS NOT NULL;`,
    `DROP TABLE \`${table}\`;`,
    `ALTER TABLE \`${table}_new\` RENAME TO \`${table}\`;`,
    `CREATE INDEX IF NOT EXISTS \`${table}_index\` ON \`${table}\` ('flightId' ASC,'obsolete' ASC);`,
    `CREATE UNIQUE INDEX IF NOT EXISTS \`${table}_rowId\` ON \`${table}\`(\`rowId\`);`,
  ];
}

export function getSqlDateTime_yyyymmdd_hhmm(str: string): Date {
  if (str.length > 10) {
    const regex = /^20[0-9}]{2}-[0-1][0-9]-[0-3][0-9] [0-9]{4}$/g;

    if (!regex.test(str)) {
      classCom.promptMessage("could not translate time yyyy-mm-dd hhss from string: " + str, msgCatStruct.err);
      return null;
    }
    // e.g. 2021-01-12 1220
    str = str.replace(/'/g, "").replace(/"/g, "");
    const y = parseInt(str.substr(0, 4));
    const m = parseInt(str.substr(5, 2));
    const d = parseInt(str.substr(8, 2));
    const h = parseInt(str.substr(11, 2));
    const min = parseInt(str.substr(13, 2));
    return new Date(y, m - 1, d, h, min);
  } else {
    const regex = /^[0-9]{4}$/g;
    if (!regex.test(str)) {
      classCom.promptMessage("could not translate time hhss from string: " + str, msgCatStruct.err);
      return null;
    }
    // e.g. 1220 -> which  means we set the current utc day
    const hx: string = str.substr(0, 2);
    const minx: string = str.substr(2, 2);

    const utcdate: Date = new Date();

    const returnDate = new Date(
      utcdate.getFullYear(),
      utcdate.getMonth(),
      utcdate.getDate(),
      parseInt(hx),
      parseInt(minx),
      0
    );
    return returnDate;
  }
}

export function formatTimespanHHmm(ts: number): string {
  const diff: number = ts;
  let msec: number = diff;
  const hh: number = Math.floor(msec / 1000 / 60 / 60);
  msec -= hh * 1000 * 60 * 60;

  const mm: number = Math.floor(msec / 1000 / 60);
  msec -= mm * 1000 * 60;

  return padLeft(hh.toString(), "0", 2).slice(-2) + ":" + padLeft(mm.toString(), "0", 2).slice(-2);
}

export function getUtcTime(lclTime: Date): Date {
  const localOffset = lclTime.getTimezoneOffset() * 60000;
  const utc = lclTime.getTime() + localOffset;

  return new Date(utc);
}

export function getLocalTime(utcTime: Date): Date {
  const localOffset = utcTime.getTimezoneOffset() * 60000;
  const utc = utcTime.getTime() + localOffset;

  return new Date(utc);
}

/**
 * The rows of one scope that carry `parameter`, rebuilt rather than handed
 * over: a caller that mutates what it gets back must not edit the cached row,
 * and the returned struct carries exactly the fields getParameter has always
 * set.
 */
function pickParameter(scope: parameterStruct[], parameter: property): parameterStruct[] {
  const hits: parameterStruct[] = [];
  for (const row of scope) {
    // eslint-disable-next-line eqeqeq
    if (row.parameter == parameter) {
      const currPara = new parameterStruct();
      currPara.value = row.value;
      currPara.blob = row.blob;
      currPara.json = row.json;
      currPara.geoJson = row.geoJson;
      currPara.markdown = row.markdown;
      hits.push(currPara);
    }
  }
  return hits;
}

export async function getParameter(
  parameterHash: string,
  tableSuffix: string,
  parameter: property,
  opsMissionType: opsMissionTypeEnum
): Promise<parameterStruct[]> {
  // The run cache holds whole scopes, and this entry's predicate is the scope
  // predicate plus paramTypeId — so a cached scope answers this read too. A
  // miss reads the WHOLE scope rather than this one row, because one row is not
  // the scope and storing it would make the next getParametersArray return that
  // row as the whole set. See the miss branch below for why reading more is
  // cheaper here.
  //
  // The cache is asked BEFORE the pending writes are flushed, and that order is
  // the point. A scope is in the map only because it was read, and every
  // `addParameter` after that upserts into it — so a cached scope already
  // carries this run's pending writes and needs no flush to be correct. Asking
  // the database is what a pending write would invalidate, and that is the
  // branch the flush guards. Flushing first instead closed the batch on every
  // read, which is most of the calculation chain.
  const cachedScope = paramCache.getScope(parameterHash, tableSuffix, opsMissionType);
  if (cachedScope) {
    return pickParameter(cachedScope, parameter);
  }

  // Cache miss, cache ON: read the whole scope instead of this one row, and let
  // getParametersArray store it. The extra rows cost one response; leaving the
  // scope cold cost far more, because the NEXT single read misses again — and a
  // miss flushes the pending writes before it queries, which is what sent the
  // accumulated parameters out one at a time. This miss was NOT the cause of the
  // 117 lone paramInserts in 330 requests of one ara-dev recompute: there
  // `POST /commands` answered 405, so each batch was replayed one write per
  // request.
  if (paramCache.isActive()) {
    const scope = await getParametersArray(parameterHash, tableSuffix, opsMissionType);
    return pickParameter(scope, parameter);
  }

  // Cache OFF (outside withParamCache): nothing would keep the wider read, so
  // ask for the one row, as this function always did.
  //
  // The database is about to answer, so anything pending for this scope has to
  // land first. Scope-targeted, so an unrelated flight or mission does not
  // close the batch.
  await flushPendingParametersForScope(parameterHash, tableSuffix, opsMissionType);

  const result = await classCom.namedQuery("paramByHashSuffixTypeMission", {
    parameterHash,
    opsMissionType,
    tableSuffix,
    paramTypeId: parameter,
  });

  const returnObj: parameterStruct[] = [];

  for (let index = 0; index < result.length; index++) {
    const value = result[index];
    const currPara = new parameterStruct();

    currPara.value = value.paramValString;
    currPara.blob = value.paramValBlob;
    currPara.json = value.paramValJson;
    currPara.geoJson = value.paramValGeoJson;
    currPara.markdown = value.paramValMarkDown;
    returnObj.push(currPara);
  }

  return returnObj;
}

export async function getParameterValue(
  parameterHash: string,
  tableSuffix: string,
  parameter: property,
  opsMissionType: opsMissionTypeEnum
): Promise<string | undefined> {
  const r = await getParameter(parameterHash, tableSuffix, parameter, opsMissionType);
  return r[0]?.value;
}

export async function getParameterNumber(
  parameterHash: string,
  tableSuffix: string,
  parameter: property,
  opsMissionType: opsMissionTypeEnum,
  fallback: number = 0
): Promise<number> {
  const v = await getParameterValue(parameterHash, tableSuffix, parameter, opsMissionType);
  return Number(v ?? fallback);
}

export async function getParameterString(
  parameterHash: string,
  tableSuffix: string,
  parameter: property,
  opsMissionType: opsMissionTypeEnum,
  fallback: string = ""
): Promise<string> {
  const v = await getParameterValue(parameterHash, tableSuffix, parameter, opsMissionType);
  return v ?? fallback;
}

export function getParameterOfArray(
  flightId: string,
  tableSuffix: string,
  parameter: property,
  arr: parameterStruct[]
): parameterStruct[] {
  const returnObj: parameterStruct[] = [];

  for (let index = 0; index < arr.length; index++) {
    const value = arr[index];
    if (value.parameter == parameter) {
      let currPara = new parameterStruct();
      currPara = value;

      returnObj.push(currPara);
    }
  }

  return returnObj;
}

function buildParameterStruct(row: any, tableSuffix: string): parameterStruct {
  const p = new parameterStruct();
  p.tableSuffix = tableSuffix;
  p.parameter = row.paramTypeId;
  p.value = row.paramValString;
  p.blob = row.paramValBlob;
  p.json = row.paramValJson;
  p.geoJson = row.paramValGeoJson;
  p.markdown = row.paramValMarkDown;
  return p;
}

export async function getParametersArray(
  flightId: string,
  tableSuffix: string,
  opsMissionType: opsMissionTypeEnum
): Promise<parameterStruct[]> {
  // Cache first, flush second — see getParameter for why that order is safe.
  const cached = paramCache.getScope(flightId, tableSuffix, opsMissionType);
  if (cached) {
    // A copy of the list, not of the rows: callers sort and splice what they
    // get, and several hold it while the chain writes. The rows themselves are
    // replaced on write, never edited in place.
    return cached.slice();
  }

  // Scope-targeted flush — see getParameter. A read of another flight's or
  // another mission's parameters does not wait for this one's writes.
  // Before the flush — see the overlap rule in param-cache.ts.
  const token = paramCache.readToken(flightId, tableSuffix, opsMissionType);
  await flushPendingParametersForScope(flightId, tableSuffix, opsMissionType);

  const result = await classCom.namedQuery("paramsByHashSuffixMission", {
    parameterHash: flightId,
    opsMissionType,
    tableSuffix,
  });

  const returnObj: parameterStruct[] = [];
  for (let index = 0; index < result.length; index++) {
    returnObj.push(buildParameterStruct(result[index], tableSuffix));
  }
  paramCache.setScope(flightId, tableSuffix, opsMissionType, returnObj, token);
  return returnObj;
}

/** Bulk parameter reads are issued in slices of this many hashes. */
export const PARAM_BULK_CHUNK_SIZE = 250;

export async function getParametersArrayBulk(
  parameterHashes: string[],
  tableSuffix: string,
  opsMissionType: opsMissionTypeEnum
): Promise<Map<string, parameterStruct[]>> {
  const out = new Map<string, parameterStruct[]>();
  if (parameterHashes.length === 0) return out;

  const dedupedHashes = Array.from(new Set(parameterHashes));
  for (const h of dedupedHashes) out.set(h, []);

  // Serve what the run cache already holds and query only the rest. Each hash
  // is its own scope here, so a partly-warm list still saves the warm part.
  const toQuery: string[] = [];
  for (const h of dedupedHashes) {
    const cached = paramCache.getScope(h, tableSuffix, opsMissionType);
    if (cached) {
      out.set(h, cached.slice());
    } else {
      toQuery.push(h);
    }
  }
  if (toQuery.length === 0) return out;

  // Flush once, for the hashes this call will actually ASK the database about —
  // the cached ones already carry their pending writes. It was inside the chunk
  // loop and passed the whole input list, so one uncached hash flushed on
  // behalf of every cached one, once per chunk.
  // One token per hash for the whole call, taken before the flush — see getParametersArray.
  const tokens = new Map(toQuery.map((h) => [h, paramCache.readToken(h, tableSuffix, opsMissionType)]));
  await flushPendingParametersForScope(toQuery, tableSuffix, opsMissionType);

  // Chunked, to bound how much of the result set is live at once. The single
  // query materialised every matching row in one go — measured at 23 MB in one
  // macrotask tick in the field — and each row's blob/json/geoJson/markdown
  // columns are copied several times on the way to JS.
  //
  // Only the memory bound is ported from cap-7 8e9a072c. Its other half,
  // projecting the query down to parameterHash/paramTypeId/paramValString,
  // needs a narrowed catalog entry, and the catalog is drift-locked with
  // efb-app-server's copy: an entry that exists only here is a 400 on the web
  // SPA, which runs this same function. See ../TODO.md.
  for (let start = 0; start < toQuery.length; start += PARAM_BULK_CHUNK_SIZE) {
    const chunk = toQuery.slice(start, start + PARAM_BULK_CHUNK_SIZE);

    const result = await classCom.namedQuery("paramsByHashListSuffixMission", {
      parameterHashes: chunk,
      opsMissionType,
      tableSuffix,
    });

    for (let index = 0; index < result.length; index++) {
      const row = result[index];
      const bucket = out.get(row.parameterHash);
      if (bucket) bucket.push(buildParameterStruct(row, tableSuffix));
    }

    // Every hash in the chunk now holds its COMPLETE row set — a hash the query
    // matched no row for keeps the empty list it was seeded with, which is the
    // right answer and worth caching.
    for (const h of chunk) {
      paramCache.setScope(h, tableSuffix, opsMissionType, out.get(h) ?? [], tokens.get(h)!);
    }
  }
  return out;
}

const timestampsUsed: number[] = [];

/**
 * The classified reason behind a rejected sync write, or `undefined` when there
 * is none to read.
 *
 * The app-server's /command route maps every CLASSIFIED applyOps reject to HTTP
 * 409 (efb-app-server src/api/dispatch.ts) — `lww` (concurrent equal-or-newer
 * row) AND `not-found` AND `immutable` (the write would have changed a
 * domain-immutable column on an existing row) AND,
 * after the D1/D2 savepoint change, the bind/constraint throw message from the
 * per-op SAVEPOINT catch. The route ships the reason in the body as
 * `{ error: result.reason, ... }`, surfaced verbatim as `HttpError.body`. **The
 * status alone therefore says nothing** — always discriminate on the reason.
 *
 * Not every reject is a 409, and this deliberately returns `undefined` for the
 * rest: since efb-app-server 7c7514a a serverFault reject (the kernel ACKed the
 * write but the local typed projection refused the row) is a **500**, and a
 * transient one a **503**. Do not rewrite this as "not 200 means 409".
 */
export function sync409Reason(opErr: unknown): string | undefined {
  if ((opErr as { status?: number })?.status !== 409) return undefined;
  const body = (opErr as { body?: unknown })?.body;
  if (typeof body !== "string" || body.length === 0) {
    // No structured body to discriminate on. Callers must treat `undefined` as
    // "not classifiable", never as "benign" — a genuine write fault with a
    // truncated body would otherwise vanish.
    return undefined;
  }
  try {
    const reason = (JSON.parse(body) as { error?: unknown })?.error;
    return typeof reason === "string" ? reason : undefined;
  } catch {
    return undefined;
  }
}

/**
 * A concurrent equal-or-newer row won; this write was a no-op and nothing was
 * lost. The ONLY 409 reason that may be swallowed silently — every other one,
 * including a STRICT-type bind/coercion failure on the `param` table, is a real
 * write fault that must not vanish as data-loss.
 */
export function isBenignLwwReject(opErr: unknown): boolean {
  return sync409Reason(opErr) === "lww";
}

/**
 * The server refused this write because it would have rewritten a recorded
 * attestation. Unlike `lww` this is NOT a no-op to swallow: the caller's write
 * did not land, and the row that is there may carry different values. Callers
 * must reconcile, not ignore.
 *
 * **This predicate is LIVE — do not delete it as unreachable.** Its original
 * source, `ops.ts flightcrewSignatureCheck` (first-writer-wins), was deleted on
 * 2026-08-13, and grepping for that name finds nothing on the server. The reason
 * came back on 2026-08-14 on different grounds: an upsert onto an EXISTING row
 * that sends a domain-immutable column (`ident`, `dutyFrom`, `created`,
 * `pilotInCommand`, `signature`) with a DIFFERENT value is rejected `immutable`
 * before the SAVEPOINT. Removing this, or the `if (!isImmutableReject(err))`
 * reconcile in `duty-ofp-limits-page.component.ts`, restores the "Sign button
 * does nothing, no message" defect verbatim.
 */
export function isImmutableReject(opErr: unknown): boolean {
  return sync409Reason(opErr) === "immutable";
}

/**
 * The signature a calculation being written right now belongs to: the
 * flightcrew row (`flightCrewId`) the flight points at *at this moment*, frozen
 * into the report row by its `signatureId` column.
 *
 * Reading it here and storing it is the whole point. `flightlist.flightCrewId`
 * is a POINTER and it MOVES — a re-sign repoints every not-yet-departed flight
 * at the new signature record — so resolving a calculation's signature through
 * it after the fact reports whichever signature is newest, not the one the
 * numbers were computed under.
 *
 * Returns `""` when the flight has no resolvable crew (an unsigned or ad-hoc
 * flight mid-creation). Stored as `""` rather than throwing: an unsigned
 * calculation is a legitimate state, and blocking the write would be a far
 * worse failure than an unattributed row. Distinguish it from the NULL that
 * pre-2026-08-13 rows carry — NULL means "unknown", `""` means "none yet".
 */
export async function currentSignatureId(flightId: string, com: any): Promise<string> {
  try {
    const rows = (await com.namedQuery("flightlistByFlightId", { flightId })) ?? [];
    // Row selection MIRRORS fccProvider.getDutyIdOfFlight exactly — default to
    // row 0, then let a changed duty (dutyId 0) supersede it, LAST match wins.
    // Both details are load-bearing: `==` because the column may come back as a
    // number, and last-wins because that is what the rest of the app resolves.
    // Diverge here and a calculation is attributed to a different signature than
    // the one every other surface reports for the same flight.
    let useIdx = 0;
    for (let li = 0; li < rows.length; li++) {
      // eslint-disable-next-line eqeqeq
      if (rows[li]?.dutyId == "0") useIdx = li;
    }
    return String(rows[useIdx]?.flightCrewId ?? "");
  } catch (err) {
    console.log("currentSignatureId: could not resolve for " + flightId + " " + err);
    return "";
  }
}

/**
 * Do two sets of duty limits agree, for the purpose of deciding whether a
 * refused re-sign lost anything?
 *
 * Compared truncated on purpose. `getDutyLimits` reads the stored row through
 * `parseInt`, so a stored OAT of 281.846 K comes back as 281 while the value
 * the pilot just entered is still 281.846. A raw `===` would call every
 * unchanged re-sign a mismatch and fire a "your edits were NOT saved" warning
 * on a duty where nothing changed — the fastest way to teach a crew to ignore
 * that warning. `Math.trunc` matches `parseInt` for both signs at these
 * magnitudes.
 *
 * `pilotNotes` is deliberately excluded: `getDutyLimits` does not read it back
 * at all, and it enters neither the signature nor any calculation.
 */
export function signedLimitsMatch(stored: limitsStruct, entered: limitsStruct): boolean {
  const same = (a: number, b: number) => Math.trunc(a) === Math.trunc(b);
  return (
    same(stored.extraWeight, entered.extraWeight) &&
    same(stored.extraFuel, entered.extraFuel) &&
    same(stored.standardFuel, entered.standardFuel) &&
    same(stored.qnh, entered.qnh) &&
    same(stored.oat, entered.oat)
  );
}

/**
 * True when the newest stored signed limits differ from the ones a page loaded.
 * With no stored signature there is nothing to overwrite.
 */
export function signedLimitsChanged(loaded: limitsStruct | undefined, stored: limitsStruct | undefined): boolean {
  if (!stored) return false;
  if (!loaded) return true;
  return !signedLimitsMatch(loaded, stored);
}

// Accumulator entries are {name, params} records — the exact shape namedCommand
// and namedCommandBatch both take, so a batch can fall back to a serial replay
// without reshaping anything.
//
// The flush sends the list in batched requests (POST /commands): one request,
// or one per chunk when the list passes a limit (see `applyBatched`). It used to
// dispatch them one namedCommand at a time, which on the web is one HTTP round
// trip per parameter: a recompute writes ~813 of them, so at a 50 ms cloud RTT
// the flush alone cost ~40 s. The legacy multi-statement raw-SQL script flush
// was retired with the named-query catalog and nothing replaced it until now.
type AccumulatedOp = {
  name: string;
  params: Record<string, unknown>;
  /**
   * Present only for an op `queueCommand` queued. Settles that call's own
   * returned promise from whatever this flush actually did with the op,
   * instead of feeding the paramInsert-only landedRowIds/rollback logic below
   * — a queued command is never a parameter and must never drive it.
   */
  settle?: { resolve: () => void; reject: (err: unknown) => void };
};
let accumulatedOps: AccumulatedOp[] = [];
let accumplatedUids: string[] = [];
/**
 * Single-flight guard. Two callers can reach a flush at once now that reads
 * flush too (a read inside one calculation step while another step's explicit
 * flush is still in the air). One flush runs at a time; a caller that finds
 * one in flight waits for it and then sends what was queued meanwhile.
 */
let flushInFlight: Promise<void> | null = null;

/**
 * Flush only if a pending write would change what this read returns.
 *
 * The accumulator exists to turn ~813 single-row writes into a handful of
 * requests, and a blanket flush-on-read gives that back: the calculation chain
 * interleaves reads and writes constantly, so every read would close the batch.
 * A param row is addressed by (parameterHash, tableSuffix, opsMissionType), and
 * that is exactly what a read asks for — so the test is a scope match, which is
 * both precise and cheap (the pending list is a few hundred entries at most).
 *
 * `hash` takes the bulk read's array as well as one hash.
 */
async function flushPendingParametersForScope(
  hash: string | string[],
  tableSuffix: string,
  opsMissionType: opsMissionTypeEnum
): Promise<void> {
  // A flush in flight sends only what was queued when it started. Wait for it,
  // then look again: this read's scope may have been queued since.
  while (flushInFlight) {
    await flushInFlight;
  }
  if (accumulatedOps.length === 0) {
    return;
  }
  const hashes = Array.isArray(hash) ? new Set(hash) : new Set([hash]);
  const touched = accumulatedOps.some(
    (op) =>
      op.params.tableSuffix === tableSuffix &&
      op.params.opsMissionType === opsMissionType &&
      hashes.has(op.params.parameterHash as string)
  );
  if (!touched) {
    return;
  }
  await execAccuParameters();
}

/** Flush everything accumulated, if anything is. */
export async function flushPendingParameters(): Promise<void> {
  if (accumulatedOps.length === 0 && !flushInFlight) {
    return;
  }
  await execAccuParameters();
}

/**
 * Shape a batch reject the way the single-row `/command` route's HttpError
 * would, so a queued command's caller can read it with the exact same
 * predicates (`isBenignLwwReject`, `isImmutableReject`, `sync409Reason`) it
 * already uses on a non-batched failure. Branch on the FIELDS the same way
 * `NamedCommandResult` itself says to, never on `reason` text — serverFault
 * is the kernel-held-but-locally-refused case (500, not retryable), retryable
 * is the transient case (503), and everything else is a classified 409 whose
 * body carries the reason for `sync409Reason` to parse.
 */
function httpErrorFromReject(r: NamedCommandResult): HttpError {
  const body = JSON.stringify({ error: r.reason, retryable: r.retryable, terminal: r.terminal });
  if (r.serverFault) {
    return new HttpError(500, "/command", body);
  }
  if (r.retryable) {
    return new HttpError(503, "/command", body);
  }
  return new HttpError(409, "/command", body);
}

export async function execAccuParameters() {
  // Wait for a flush in flight, then send what was queued meanwhile.
  while (flushInFlight) {
    await flushInFlight;
  }
  if (accumulatedOps.length === 0) {
    return;
  }
  let release: () => void = () => undefined;
  flushInFlight = new Promise<void>((resolve) => (release = resolve));
  try {
    await execAccuParametersInner();
  } finally {
    flushInFlight = null;
    release();
  }
}

async function execAccuParametersInner() {
  // Concrete rowIds this flush ACTUALLY landed — i.e. paramInserts that wrote a
  // row server-side. Tracking is row-level, NOT scope-level (parameterHash,
  // tableSuffix): a single scope routinely holds many distinct rowIds (one per
  // paramTypeId), so undoing a whole scope on rollback would soft-delete rows
  // this flush never wrote. A 409-LWW-skipped op wrote nothing (the server kept
  // its own committed row) and its rowId is therefore NOT recorded, so the
  // rollback leaves that live committed row untouched — undoing only what we
  // actually added, never collateral committed INPUT data.
  const landedRowIds = new Set<string>();
  const recordLanded = (rowId: unknown) => {
    if (rowId != null && rowId !== "") {
      landedRowIds.add(String(rowId));
    }
  };

  // Serial replay — the original path, kept for two reasons. It is what a
  // server too old for /commands falls back to, and it is what runs when the
  // batch request fails at the transport (no per-op verdict came back, so the
  // only honest way to learn what landed is to ask again). Every op is an
  // idempotent upsert on a deterministic rowId, so replaying one that already
  // landed rewrites the same values.
  const applySerially = async (ops: AccumulatedOp[]) => {
    // A parameter fault stops the PARAMETERS behind it, as it always did. A
    // queued command behind it is still sent: before it joined the flush it
    // was its own request after the flush, which swallows the fault.
    let paramFault: unknown;
    for (const op of ops) {
      if (paramFault !== undefined && !op.settle) continue;
      try {
        await classCom.namedCommand(op.name, op.params);
        if (op.name === "paramInsert" && !op.settle) {
          recordLanded(op.params.rowId);
        }
        op.settle?.resolve();
      } catch (opErr) {
        // A queued command settles its own caller directly from whatever
        // namedCommand did with it, and — same rule as the batched path below
        // — never stops the replay or feeds the parameter rollback: only a
        // paramInsert result may do that.
        if (op.settle) {
          op.settle.reject(opErr);
          continue;
        }
        // A 409 from the app-server is only a benign LWW-reject when the
        // server's reason is 'lww' (it already holds an equal-or-newer row for
        // this op, so the write was a no-op). Skip it and keep applying the
        // rest of the batch — and crucially do NOT record its rowId as landed,
        // so the rollback below never soft-deletes that live committed row on a
        // benign collision (e.g. a concurrent same-row recalc), which would
        // wipe the flight's committed INPUT data. Every OTHER 409 (not-found, or a
        // server-side bind/constraint throw — the `param` table is STRICT and
        // rejects unbindable values) is a real write fault and falls through
        // to throw, so it surfaces rather than silently losing the param. The
        // browser DB service throws HttpError with `status` + `body`; native
        // never reaches here (pwa-gated). Mirrors fuelCalcReport.ts.
        if (isBenignLwwReject(opErr)) continue;
        paramFault = opErr;
      }
    }
    if (paramFault !== undefined) throw paramFault;
  };

  // One request for each chunk of the list. The server runs the same ops through the
  // same path and reports each outcome in request order, so a per-op reject
  // still means exactly what it means on /command — including which rowIds
  // landed, which is what the rollback below needs.
  //
  // Difference from the serial path, deliberate: a fault no longer stops the
  // ops behind it, because by the time the response arrives they have all run.
  // They land, so they are recorded, so the rollback undoes them too. That is a
  // superset of what the serial path undid, never a subset — no row survives
  // that the old path would have removed.
  // The app-server takes at most 1 MiB per request (Fastify's default body
  // limit), and one performance report is about half of that. It also takes at
  // most 1000 ops per request (`MAX_COMMAND_BATCH_OPS`). So the flush goes out
  // in chunks under both limits, in queue order. An op over the size cap on
  // its own goes alone: the single-row route has the same limit.
  // ponytail: JSON length counts characters, not UTF-8 bytes; the margin
  // below 1 MiB covers the few non-ASCII ones a report carries.
  const MAX_BATCH_CHARS = 768 * 1024;
  const applyBatched = async (ops: AccumulatedOp[]) => {
    const chunks: AccumulatedOp[][] = [[]];
    let size = 0;
    for (const op of ops) {
      const opSize = JSON.stringify({ name: op.name, params: op.params }).length;
      const current = chunks[chunks.length - 1];
      if (current.length > 0 && (size + opSize > MAX_BATCH_CHARS || current.length >= MAX_COMMAND_BATCH_OPS)) {
        chunks.push([]);
        size = 0;
      }
      chunks[chunks.length - 1].push(op);
      size += opSize;
    }
    // One request per chunk, each handled as a whole flush was. A parameter
    // fault in one chunk does not stop the next: in one request, every op ran
    // too. The first fault is rethrown for the rollback.
    let fault: unknown;
    for (const chunk of chunks) {
      try {
        await applyBatchedChunk(chunk);
      } catch (err) {
        fault ??= err;
      }
    }
    if (fault !== undefined) throw fault;
  };
  const applyBatchedChunk = async (ops: AccumulatedOp[]) => {
    let results: NamedCommandResult[];
    try {
      // Send the wire shape only — a queued command's settle callbacks are
      // this module's own bookkeeping, not part of the request.
      results = await classCom.namedCommandBatch(ops.map(({ name, params }) => ({ name, params })));
    } catch (batchErr) {
      // No per-op verdict. The server may have applied all, some or none of
      // them, so replay serially rather than guess — that both learns what
      // landed and restores the old path's exact rollback scope.
      console.log("warn: batched parameter flush failed, replaying serially: " + batchErr);
      await applySerially(ops);
      return;
    }
    // The server reports each op's outcome in request order (see the comment
    // above), so `results[i]` is `ops[i]`'s own verdict — that positional
    // pairing is what lets a queued command's settle be found here.
    //
    // Settle every queued command FIRST. The loop below stops at the first
    // parameter fault, and a queued command after it has a verdict too: its
    // row may have landed. A queued command is never a parameter, so its
    // reject — benign LWW included — goes to its caller as an HttpError
    // shaped like the single-row /command route, and never joins the
    // paramInsert-only landedRowIds/rollback bookkeeping below.
    results.forEach((r, i) => {
      const settle = ops[i]?.settle;
      if (!settle) return;
      if (r.kind === "ack") settle.resolve();
      else settle.reject(httpErrorFromReject(r));
    });
    for (let i = 0; i < results.length; i++) {
      const r = results[i];
      if (ops[i]?.settle) continue;
      if (r.kind === "ack") {
        if (r.name === "paramInsert") {
          recordLanded(r.rowId);
        }
        continue;
      }
      // Same rule as the serial path: `lww` is the one reject that means the
      // write was a no-op, and its rowId is NOT recorded, so the rollback
      // leaves the live committed row alone. Everything else is a real fault.
      if (isBenignBatchReject(r)) continue;
      throw new Error(`parameter flush rejected (${r.name}, rowId ${r.rowId}): ${r.reason ?? "unknown"}`);
    }
  };

  // Take the ops out of the queue BEFORE the request. The recycle runs its
  // mission types in parallel, so another mission queues ops while this flush
  // waits for the server. Emptying the queue after the await dropped those ops
  // unsent: their loading elements existed with no parameters, and mass and
  // balance failed on every mission but one. Native never queues.
  const ops = accumulatedOps;
  accumulatedOps = [];
  accumplatedUids = [];
  try {
    if (classCom.batchedWrites) {
      await applyBatched(ops);
    } else {
      await applySerially(ops);
    }
  } catch (error) {
    console.log("error: can set parameters! rolback! " + error);
    // Roll back ONLY the concrete rowIds this flush actually landed — soft-delete
    // each by rowId, NOT by reconciling whole (parameterHash, tableSuffix) scopes
    // to ∅. A scope holds many rowIds across paramTypeIds; reconcile-to-∅ would
    // wipe every live row in the scope, including 409-LWW-skipped committed rows
    // (server held an equal-or-newer row) and rows written by an unrelated path —
    // collateral INPUT data loss. rowIds for 409-skipped ops and for ops that
    // never ran (after the throwing op) are absent from `landedRowIds`, so they
    // are preserved.
    const updatedAt = new Date().getTime();
    for (const rowId of landedRowIds) {
      try {
        await classCom.namedCommand("paramDeleteByRowId", { rowId, updatedAt });
      } catch (delErr) {
        // Web: a 409 means the row is already gone or a newer write won —
        // benign for a one-directional soft-delete. Any other error surfaces.
        if ((delErr as { status?: number })?.status === 409) continue;
        throw delErr;
      }
    }
    // The run cache was written through as each of those ops was accumulated,
    // so after a rollback it describes rows the database does not hold. Which
    // ones is not worth working out — drop it all and let the next read go to
    // the database.
    paramCache.clear();
  } finally {
    // A queued command the flush never sent (a parameter fault stopped the
    // serial replay first, or the rollback threw) must not hang. Settling a
    // settled promise does nothing, so this reaches only those.
    for (const op of ops) op.settle?.reject(new Error(`not sent: the flush stopped before ${op.name}`));
  }
}

let cnt: number = 0;
function buildParameterRow(
  uid: string,
  tableSuffix: string,
  paramTypeId: property,
  opsMissionType: opsMissionTypeEnum,
  value: string,
  paramValBlob: string,
  json: string,
  geoJson: string,
  markdown: string
) {
  let newTimestamp = new Date().getTime();

  newTimestamp += cnt;
  cnt += 1;

  if (timestampsUsed.length > 25) {
    timestampsUsed.splice(0, 1);
  }

  const insertParams = {
    rowId: rowIdFor([uid, paramTypeId, tableSuffix, opsMissionType]),
    timestamp: newTimestamp.toString(),
    parameterHash: uid,
    paramTypeId: paramTypeId.toString(),
    opsMissionType,
    tableSuffix,
    paramValString: value,
    paramValBlob,
    paramValJson: json,
    paramValGeoJson: geoJson,
    paramValMarkDown: markdown,
    // Server-only LWW stamp (web sync path); mobile catalog SQL ignores it.
    updatedAt: new Date().getTime(),
  };

  // Write through the run cache so a read that follows this write sees it
  // without going to the database. Mirrors what buildParameterStruct would make
  // of this row read back, paramTypeId included — the column is TEXT, so a
  // read-back gives the string form and every comparison against it is loose.
  const cachedRow = new parameterStruct();
  cachedRow.parameter = insertParams.paramTypeId as unknown as property;
  cachedRow.tableSuffix = tableSuffix;
  cachedRow.value = value;
  cachedRow.blob = paramValBlob;
  cachedRow.json = json;
  cachedRow.geoJson = geoJson;
  cachedRow.markdown = markdown;
  paramCache.upsertParam(uid, tableSuffix, opsMissionType, paramTypeId, cachedRow);
  // An accumulated write issues no command, so nothing else would tell the
  // efb_user read cache that the param table moved. Both branches invalidate
  // here rather than only the deferred one — the immediate branch's own
  // command invalidates again, which costs nothing.
  userReadCache.invalidateForWrite("paramInsert");
  return insertParams;
}

/**
 * One parameter row that joins the next parameter flush without taking part
 * in its rollback. The caller must flush (`execAccuParameters`) before it
 * awaits the result. Native writes at once.
 */
export async function queueParameter(
  uid: string,
  tableSuffix: string,
  paramTypeId: property,
  opsMissionType: opsMissionTypeEnum,
  value: string,
  paramValBlob: string,
  json: string,
  geoJson: string,
  markdown: string
): Promise<void> {
  const params = buildParameterRow(
    uid,
    tableSuffix,
    paramTypeId,
    opsMissionType,
    value,
    paramValBlob,
    json,
    geoJson,
    markdown
  );
  // Native writes at once, by the rules of an immediate `addParameter`.
  if (!classCom.batchedWrites) return writeParameterNow(params, uid, tableSuffix, opsMissionType);
  return queueCommand({ name: "paramInsert", params }).catch((err) => {
    // The cache took the value when the row was built. The database did not.
    paramCache.dropScope(uid, tableSuffix);
    throw err;
  });
}

/** Send one parameter row now, after the pending writes of its scope. */
async function writeParameterNow(
  insertParams: Record<string, unknown>,
  uid: string,
  tableSuffix: string,
  opsMissionType: opsMissionTypeEnum
): Promise<void> {
  // Writes must land in the order the program issued them. `updatedAt` is
  // stamped here, not at flush time, so a deferred op carries an OLDER stamp
  // than an immediate write issued after it — and if the immediate one lands
  // first, the server refuses the deferred one with `lww` and the mission
  // fails outright ("could not be fully recalculated"). Flushing the pending
  // ops for this scope first restores the issue order. Scope-targeted, so an
  // unrelated flight or mission does not close the batch.
  // The database may answer a read of this scope before this write lands.
  // While the write is open, no such read keeps its answer.
  paramCache.writeOpened(uid, tableSuffix, opsMissionType);
  try {
    await flushPendingParametersForScope(uid, tableSuffix, opsMissionType);
    await classCom.namedCommand("paramInsert", insertParams);
  } catch (err) {
    // The cache was written a moment ago on the assumption this lands. It
    // did not, so drop the scope rather than serve a value the database
    // never took.
    paramCache.dropScope(uid, tableSuffix);
    throw err;
  } finally {
    paramCache.writeSettled(uid, tableSuffix, opsMissionType);
  }
}

export async function addParameter(
  uid: string,
  tableSuffix: string,
  paramTypeId: property,
  opsMissionType: opsMissionTypeEnum,
  value: string,
  paramValBlob: string,
  json: string,
  geoJson: string,
  markdown: string,
  accumulateScript: boolean
) {
  // Deterministic-rowId model: the param's logical key
  // [parameterHash, paramTypeId, tableSuffix, opsMissionType] IS the rowId
  // input, which equals the old soft-delete-previous match key — so the prior
  // "mark previous deleted=1 then insert" pair collapses to a single
  // upsert-in-place (ON CONFLICT(rowId) DO UPDATE, deleted/acknowledged reset
  // to 0). No separate soft-delete enqueue/command anymore.

  // Accumulate only where a write costs an HTTP round trip. Native writes go
  // to the local SQLite, so deferring them buys nothing and would only widen
  // the window in which a crash loses them.
  //
  // This used to read `targetPlatform !== pwa`, and plugins.ts constructs
  // focMain with `na` on BOTH targets — so the condition was always true,
  // accumulation never happened anywhere, and every one of the 76 call sites
  // that asks for it wrote its own request. Do not restore the platform test:
  // two unrelated branches (flow-briefing-auto's training mode and
  // ops-control's duty-limits redirect) also read `targetPlatform == na` and
  // would change behaviour on the web if that value moved.
  if (!classCom.batchedWrites) {
    accumulateScript = false;
  }

  const insertParams = buildParameterRow(
    uid,
    tableSuffix,
    paramTypeId,
    opsMissionType,
    value,
    paramValBlob,
    json,
    geoJson,
    markdown
  );

  if (accumulateScript) {
    accumulatedOps.push({ name: "paramInsert", params: insertParams });
    accumplatedUids.push(uid);
  } else {
    await writeParameterNow(insertParams, uid, tableSuffix, opsMissionType);
  }
}

/**
 * Queue a single-row write so it lands in the same request as whatever
 * `accumulatedOps` already holds (the parameter batch `addParameter` builds),
 * instead of costing its own HTTP round trip. Building block for merging a
 * calculation step's writes. Callers: `fuelCalcReport.ts`, `navLogReport.ts`,
 * `focMain.ts` and `queueCommands` in this file.
 *
 * Native (`!classCom.batchedWrites`): a plain pass-through to
 * `classCom.namedCommand`, identical to calling it directly. Nothing queued.
 *
 * Web: appended to the SAME queue `addParameter`'s deferred writes use, so it
 * keeps its position between whatever was queued before and after it. Unlike
 * `addParameter`'s own deferred writes — which resolve as soon as they are
 * queued, because their caller only needs to know the value is cached, not
 * that it landed (see param-cache.spec's "cache before flush" describe) —
 * this returns a promise that stays pending until a LATER flush the caller
 * triggers has actually sent it. `queueCommand` never flushes by itself.
 *
 * Settling:
 *  - A batched flush's ack resolves it.
 *  - A batched flush's reject settles it into an `HttpError` shaped like the
 *    single-row `/command` route's own throw (`sync409Reason` et al. read it
 *    exactly the same way) — 500 for a serverFault, 503 for a retryable
 *    reject, 409 otherwise. This never joins the paramInsert-only
 *    landedRowIds/rollback bookkeeping: only a paramInsert result may drive
 *    that, so a queued command's own fault can never roll back a param, and a
 *    param's own fault can never be blamed on the queued command.
 *  - If the batch transport itself fails, the serial replay resends this op
 *    with `classCom.namedCommand` on its own and settles from THAT outcome —
 *    the original error on failure — without stopping the replay from
 *    reaching the ops queued after it.
 *  - Any other path out of the flush before this op was sent rejects it too,
 *    so it can never hang forever.
 */
export async function queueCommand(op: NamedCommandOp): Promise<void> {
  if (!classCom.batchedWrites) {
    await classCom.namedCommand(op.name, op.params);
    return;
  }
  // Mirrors addParameter: nothing else would tell the efb_user read cache
  // this table moved until the deferred write actually lands.
  userReadCache.invalidateForWrite(op.name);
  return new Promise<void>((resolve, reject) => {
    accumulatedOps.push({ name: op.name, params: op.params, settle: { resolve, reject } });
  });
}

/**
 * `runCommands` for a list that joins the next parameter flush. The caller
 * must flush (`execAccuParameters`) before it awaits the result. Native writes
 * at once through `runCommands`, unchanged. On web each op is queued and the
 * reject rules are `runCommands`' own: an `lww` reject is a no-op, and with
 * `tolerateMissing` so is any terminal reject.
 */
export function queueCommands(ops: NamedCommandOp[], tolerateMissing = false): Promise<void> {
  if (!classCom.batchedWrites) return runCommands(ops, tolerateMissing);
  const tolerated = (err: unknown) => {
    if (isBenignLwwReject(err)) return true;
    if (!tolerateMissing) return false;
    try {
      return JSON.parse((err as { body?: string })?.body ?? "")?.terminal === true;
    } catch {
      return false;
    }
  };
  return Promise.all(
    ops.map((op) =>
      queueCommand(op).catch((err) => {
        if (!tolerated(err)) throw err;
      })
    )
  ).then(() => undefined);
}

export async function checkFlightIdValid(flightId: string): Promise<boolean> {
  const rows = await classCom.namedQuery("flightlistExistsByFlightId", { flightId });

  if (rows.length > 0) {
    return true;
  }
  return false;
}

export async function checkFlightNumberExists(flightId: string, flightNumber: string): Promise<boolean> {
  const rows = await classCom.namedQuery("flightlistExistsByFlightIdAndNumber", { flightId, flightNumber });

  if (rows.length > 0) {
    return true;
  }
  return false;
}

export function checkFlightDuringNighttime(estTimeDep: Date, navlog: navLegStruct[], ecetDiffMin: number): boolean {
  // make an nighttime array, of which the idx is the minute of day.
  // -> to resolve, loop all minutes from to of the flight and see whether one of those is
  //    within nighttime

  const startTicks: number = estTimeDep.getTime() / 60000;
  const endOfRouteTime = new Date(startTicks * 60000);
  endOfRouteTime.setSeconds(endOfRouteTime.getSeconds() + navlog[navlog.length - 1].totalTime);
  const endTicks: number = endOfRouteTime.getTime() / 60000;

  const nightTimeRegister_lst: boolean[] = [];

  for (let ticks = startTicks; ticks < endTicks; ticks++) {
    const ticks_ts = new Date(ticks * 60000);

    const sunset = classCom.package_sunriseSunset.getSunset(navlog[0].geoPos[1], navlog[0].geoPos[0], estTimeDep);
    const sunRise = classCom.package_sunriseSunset.getSunrise(navlog[0].geoPos[1], navlog[0].geoPos[0], estTimeDep);

    const ecet = addMinutes(sunset, ecetDiffMin);
    const bcet = addMinutes(sunRise, -ecetDiffMin);

    if (ticks_ts > bcet && ticks_ts < ecet) {
      nightTimeRegister_lst.push(false);
    } else {
      // that should be enough, keep the array though if we need more detail later
      return true;
      nightTimeRegister_lst.push(true);
    }
  }

  return false;
}
export async function getFirstNvfrWpt(estTimeDep: Date, navlog: navLegStruct[], ecetDiffMin: number): Promise<string> {
  // make an nighttime array, of which the idx is the minute of day.
  // -> to resolve, loop all minutes from to of the flight and see whether one of those is
  //    within nighttime

  for (let N = 0; N < navlog.length; N++) {
    const startTicks: number = estTimeDep.getTime() / 60000;
    const endOfRouteTime = new Date(startTicks * 60000);
    endOfRouteTime.setSeconds(endOfRouteTime.getSeconds() + navlog[N].totalTime);
    const endTicks: number = endOfRouteTime.getTime() / 60000;

    const nightTimeRegister_lst: boolean[] = [];

    for (let ticks = startTicks; ticks < endTicks; ticks++) {
      const ticks_ts = new Date(ticks * 60000);

      const sunset = classCom.package_sunriseSunset.getSunset(navlog[0].geoPos[1], navlog[N].geoPos[0], estTimeDep);
      const sunRise = classCom.package_sunriseSunset.getSunrise(navlog[0].geoPos[1], navlog[N].geoPos[0], estTimeDep);

      const ecet = addMinutes(sunset, ecetDiffMin);
      const bcet = addMinutes(sunRise, -ecetDiffMin);

      if (ticks_ts > bcet && ticks_ts < ecet) {
        nightTimeRegister_lst.push(false);
      } else {
        // that should be enough, keep the array though if we need more detail later

        return navlog[N].desig;
      }
    }
  }
}

export async function deleteAllParameters(parameterHash: string, tableSuffix: string) {
  // Land every pending write BEFORE the reconcile enumerates the live rows.
  // The reconcile reads rowIds from the database, so a still-accumulated insert
  // is not in that set, is not deleted, and then lands afterwards — leaving a
  // live row behind a reconcile-to-empty. Unscoped, because this call spans
  // every opsMissionType and the scope key names one.
  await flushPendingParameters();

  // Reconcile-to-empty: soft-delete every live param row for this
  // (parameterHash, tableSuffix). A subsequent addParameter re-upserts the
  // still-present keys (revives deleted=0); keys not re-added stay deleted=1 —
  // the old DELETE-all-then-reinsert behaviour, now per-rowId so it sync-routes.
  await reconcileCollection(
    "paramRowIdsByHashAndSuffix",
    { parameterHash, tableSuffix },
    "paramDeleteByRowId",
    new Set<string>()
  );
  // Every mission's rows for this (hash, suffix) are gone — the cache cannot
  // follow a reconcile, so forget them.
  paramCache.dropScope(parameterHash, tableSuffix);
}

/**
 * The app-server answers 413 ("too many ops") to a POST /commands with more ops
 * than this (`MAX_COMMAND_BATCH` in efb-app-server `src/api/dispatch.ts`). The
 * caller then replays every op as its own request, about 10 per second: a crew
 * reconcile of 1000+ deletes took over a minute on dev-ara (2026-10-01).
 */
export const MAX_COMMAND_BATCH_OPS = 1000;

/**
 * Run a list of single-row writes as one request per chunk of at most
 * `MAX_COMMAND_BATCH_OPS` ops where the transport supports it, or one at a time
 * where it does not. Nothing here is deferred past the
 * call: the ops run before it resolves, exactly as the serial loop it replaces.
 *
 * `batchedWrites` is false on native, where the write is a local SQLite call
 * over the loopback plugin and there is no round trip to save. On web each op
 * was its own HTTP request, so a collection rebuild cost one per member.
 *
 * `tolerateMissing` says whether "the server does not hold this row" is a
 * no-op or a fault, and the answer differs per caller. A one-directional
 * soft-delete tolerates it — the row is already gone, which is the outcome it
 * wanted. An insert does not.
 *
 * A batch transport failure gives no per-op verdict, so the ops are replayed
 * serially rather than guessed at. The writes are idempotent upserts keyed on
 * rowId, so a replay of ops the server already applied changes nothing.
 */
export async function runCommands(ops: NamedCommandOp[], tolerateMissing = false, batchNative = false): Promise<void> {
  if (ops.length === 0) return;

  const applySerially = async (list: NamedCommandOp[]) => {
    for (const op of list) {
      try {
        await classCom.namedCommand(op.name, op.params);
      } catch (err) {
        // Web: a 409 means not-found or LWW. Native never 409s (local SQL).
        if (tolerateMissing && (err as { status?: number })?.status === 409) continue;
        throw err;
      }
    }
  };

  if (!classCom.batchedWrites && !batchNative) {
    await applySerially(ops);
    return;
  }

  // One request per chunk, in order. A failed request replays only its own chunk.
  for (let start = 0; start < ops.length; start += MAX_COMMAND_BATCH_OPS) {
    const chunk = ops.slice(start, start + MAX_COMMAND_BATCH_OPS);
    let results: NamedCommandResult[];
    try {
      results = await classCom.namedCommandBatch(chunk);
    } catch (batchErr) {
      console.log("warn: batched write failed, replaying serially: " + batchErr);
      await applySerially(chunk);
      continue;
    }
    for (const r of results) {
      if (r.kind === "ack") continue;
      if (tolerateMissing && r.kind === "reject" && r.terminal === true) continue;
      // `lww` means the server already holds an equal-or-newer row, so the write
      // was a no-op. Every other reject is a real write fault.
      if (isBenignBatchReject(r)) continue;
      throw new Error(`write rejected (${r.name}, rowId ${r.rowId}): ${r.reason ?? "unknown"}`);
    }
  }
}

/**
 * Re-plan collection reconcile (client-side, both platforms). Reads the live
 * member rowIds for a collection scope via `readEntry`, then for every live
 * rowId NOT in `keep` issues a per-row removal (`removeEntry` — an
 * obsolete/delete sync write keyed on rowId). Never a server fan-out: the
 * enumeration + diff run on the client and emit single-row Ops that route
 * through applyOps on web and run the UPDATE locally on native.
 *
 * Fresh create → live set empty → no-op. Idempotent. Legacy NULL-rowId rows
 * (pre-backfill native upgrades) are skipped — they can't be addressed by rowId
 * and are retired by the startup migration instead.
 */
export async function reconcileCollection(
  readEntry: string,
  readParams: Record<string, unknown>,
  removeEntry: string,
  keep: Set<string>,
  batchNative = false
): Promise<void> {
  // One request for the whole removal set. `tolerateMissing` keeps the old
  // per-row behaviour: a row already gone, or superseded by a newer write, is
  // the outcome a one-directional obsolete/delete wanted.
  await runCommands(await reconcileOps(readEntry, readParams, removeEntry, keep), true, batchNative);
}

/** The removal ops `reconcileCollection` would send, for a caller that sends them itself. */
export async function reconcileOps(
  readEntry: string,
  readParams: Record<string, unknown>,
  removeEntry: string,
  keep: Set<string>
): Promise<NamedCommandOp[]> {
  const rows = (await classCom.namedQuery(readEntry, readParams)) as Array<{ rowId: string | null }>;
  const updatedAt = new Date().getTime();
  const ops: NamedCommandOp[] = [];
  for (const row of rows) {
    const rowId = row?.rowId;
    if (!rowId) continue;
    if (keep.has(rowId)) continue;
    ops.push({ name: removeEntry, params: { rowId, updatedAt } });
  }
  return ops;
}

export function drawConsoleTable(obj, fs) {
  // Check if the object array is empty
  if (obj.length === 0) {
    console.log("No data available to display.");
    return;
  }

  obj.forEach((row, index) => {
    console.log(`\nFlight ${index + 1}:\n${"=".repeat(10)}`);
    Object.entries(row).forEach(([key, value]) => {
      console.log(`${key.padEnd(20)}: ${value !== undefined ? value : "N/A"}`);
    });
    console.log("\n");
  });
}

export function getTableHeader(obj, indent) {
  let lineStr = "";

  const colWidth: number[] = [];
  colWidth[0] = 25;
  for (let i = 1; i < 100 - 1; i++) {
    colWidth[i] = 18;
  }

  for (const i in obj) {
    if (Array.isArray(obj[i]) || typeof obj[i] === "object") {
      getTableHeader(obj[i], indent + " > " + i + " > ");
    } else {
      lineStr += " | " + padLeft(indent + i.toUpperCase(), " ", colWidth[i]);
    }
  }

  console.log(lineStr);

  // make that horizontal line
  let horiLineStr = " ";
  for (let i = 0; i < lineStr.length - 1; i++) {
    horiLineStr += "-";
  }

  if (horiLineStr !== "") console.log(horiLineStr);
}

export function getTableContent(obj) {
  const colWidth: number[] = [];
  colWidth[0] = 25;
  for (let i = 1; i < 100 - 1; i++) {
    colWidth[i] = 18;
  }

  let lineStr = "";
  for (const i in obj) {
    if (Array.isArray(obj[i]) || typeof obj[i] === "object") {
      /* empty */
    } else {
      lineStr += " | " + padLeft(obj[i], " ", colWidth[i]);
    }
  }

  if (lineStr !== "") {
    console.log(lineStr);
  }
}

export function padLeft(text: string, padChar: string, size: number): string {
  return (String(padChar).repeat(size) + text).substr(size * -1, size);
}
export function padRight(text: string, padChar: string, size: number): string {
  if (text.length > size - 3) {
    //text = text.substring(0, 36) + "...";
  }

  return text.padEnd(size, padChar);
}
export function isToday(someDate) {
  const today = new Date();
  return (
    someDate.getDate() == today.getDate() &&
    someDate.getMonth() == today.getMonth() &&
    someDate.getFullYear() == today.getFullYear()
  );
}

export function normalize(str: string): string {
  let stra = str
    .trim()
    .replace(/^[;,]+|[;,]+$/g, "")
    .toLowerCase(); // Optional: toLowerCase for case-insensitive match
  return stra;
}
export function parseCss(cssString: string, value: string): string {
  if (!cssString) return "";
  const splStr = cssString.split(";");

  for (let i = 0; i < splStr.length; i++) {
    const separator = splStr[i].indexOf(":");
    if (separator >= 0 && splStr[i].slice(0, separator).trim() === value) {
      try {
        const splValue: string = splStr[i].slice(separator + 1);
        if (!splValue) return "";
        return splValue.trim().replace(/[;,]+$/, "");
      } catch (err) {
        return undefined;
      }
    }
  }

  return undefined;
}

// markdown
export class svgDiagramDataStruct {
  printLightKey?: string;
  image: string;
  _violation: boolean;
  _diagram_txtName: string;
  _diagram_txtDescription: string;
  _isOei: boolean;
  _annunciator?: string;
  _isPlaceholder?: boolean;
  _appendix?: string;
  _txtCondition?: string;
  points: svgPointStruct[];
  lines: svgLineStruct[];
  parameters?: string;
  value: number;
}
export class svgPointStruct {
  desig: string;
  fontColor: string;
  position: number[];
  backgroundColor: string;
}
export class svgLineStruct {
  lineColor: string;
  lineWidth: number;
  points: number[][];
}
export class markDownProcessing {
  private static diagramSequence = 0;
  createSvgDiagram(diagram: svgDiagramDataStruct): string {
    const filterPrefix = `perf-diagram-${++markDownProcessing.diagramSequence}-`;
    if (diagram._isPlaceholder) {
      return `<svg width="100%" viewBox="0 0 1500 1024" role="img" aria-label="No content for this request" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <rect width="1500" height="1024" fill="#fafbfc"/>
        <image x="560" y="245" width="380" height="380" opacity="0.25" xlink:href="${diagram.image}"/>
        <text x="750" y="695" text-anchor="middle" font-family="Arial, sans-serif" font-size="30" font-weight="600" fill="#344252">NO CONTENT FOR THIS REQUEST</text>
        <text x="750" y="746" text-anchor="middle" font-family="Arial, sans-serif" font-size="23" fill="#647184">No matching performance configuration for the selected parameters.</text>
      </svg>`;
    }
    const width: number = Number(parseCss(diagram.parameters, "width"));
    const height: number = Number(parseCss(diagram.parameters, "height"));
    const textHeightAnnu: number = 20;

    const fontSize_px: number = 25;

    let textTemplateAnnunciator: string =
      "<defs> <filter x='0' y='0' width='1' height='1' id='annunciatorFilter'> <feFlood flood-color=yellow result='bg' /> <feMerge> <feMergeNode in='bg'/> <feMergeNode in='SourceGraphic'/> </feMerge> </filter> </defs> <text xml:space='preserve' filter='url(#annunciatorFilter)' style='font-style:bold;font-weight:bolder;font-size:" +
      textHeightAnnu +
      ";line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:black;color:black;fill-opacity:1;stroke:none' x='0' y='" +
      textHeightAnnu +
      "' id='annu-text'><tspan id='ff' style='fill:black;color:black;fill-opacity:1' x='0' y='" +
      textHeightAnnu +
      "'>{annunciatorText}</tspan></text> ";

    let annunciatorText: string = "";
    if (diagram._annunciator != undefined) {
      annunciatorText = diagram._annunciator;
    }

    textTemplateAnnunciator = textTemplateAnnunciator.replace("{annunciatorText}", annunciatorText);

    const textTemplate: string =
      " <defs> <filter x='0' y='0' width='1' height='1' id='{filterId}'> <feFlood flood-color={backgroundColor} result='bg' /> <feMerge> <feMergeNode in='bg'/> <feMergeNode in='SourceGraphic'/> </feMerge> </filter> </defs><text xml:space='preserve' filter='url(#{filterId})' style='font-style:bold;font-weight:bolder;font-size:" +
      fontSize_px +
      "px" +
      ";line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:{textColor};fill-opacity:1;stroke:none' x='{textX}' y='{textY}' id='{textId}'><tspan id='tspan8336' style='fill:{textColor};fill-opacity:1' x='{textX}' y='{textY}'>{textDesig}</tspan></text> ";
    const dotTemplate: string =
      "<circle style='fill:{dotFillColor};fill-opacity:1;stroke:none;stroke-width:" +
      "1" +
      ";stroke-linecap:round' id='{circleId}' cx='{circleX}' cy='{circleY}' r='" +
      height / (fontSize_px * 8) +
      "' />";

    const pathTemplate: string =
      "<path style='fill:none;stroke:{pathColor};stroke-width:{pathWidth};stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;stroke-miterlimit:4;stroke-dasharray:none' d='M {pathPointList}' id='{pathId}' />";
    let svgTemplate: string =
      "<svg width='100%' viewBox='0 0 " +
      width +
      " " +
      height +
      "' version='1.1' id='svg5' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'> <defs id='defs2' /> <g id='layer1'> <image width='100%' height='100%'  preserveAspectRatio='none' xlink:href='{backgroundImage}' id='image832' x='0.44516158' y='0.64575922' /> {allLines}   {allPoints} {txtAnnu} </g></svg>";
    // annunciator:

    svgTemplate +=
      "diagram above: <b>" + diagram._diagram_txtName + ": </b><i>" + diagram._diagram_txtDescription + "</i>";

    if (diagram._appendix != undefined) {
      svgTemplate += "<div>appendix: <i>" + diagram._appendix + "</i></div><br>";
    }

    // points
    let allTexts: string = "";
    let sig: number = 1;
    if (diagram.points != undefined) {
      for (let i = 0; i < diagram.points.length; i++) {
        const cPoint: svgPointStruct = diagram.points[i];
        // replace textId textColor textDesig textX textY
        let ttempl = textTemplate;
        ttempl = ttempl.replace("{textId}", "text-" + i);
        ttempl = ttempl.replaceAll("{filterId}", filterPrefix + "filter-" + i);

        ttempl = ttempl.replace("{textColor}", cPoint.fontColor);
        ttempl = ttempl.replace("{textColor}", cPoint.fontColor);
        ttempl = ttempl.replace("{textDesig}", cPoint.desig);
        ttempl = ttempl.replace("{textX}", (cPoint.position[0] + ((1.1 * sig) / 100) * height).toString());
        ttempl = ttempl.replace("{textY}", (cPoint.position[1] + (0.8 / 100) * height).toString());
        ttempl = ttempl.replace("{textX}", (cPoint.position[0] + ((1.1 * sig) / 100) * height).toString());
        ttempl = ttempl.replace("{textY}", (cPoint.position[1] + (0.8 / 100) * height).toString());
        ttempl = ttempl.replace("{backgroundColor}", cPoint.backgroundColor);

        let dtemp = dotTemplate;
        dtemp = dtemp.replace("{circleId}", "circle-" + i);
        dtemp = dtemp.replace("{circleX}", cPoint.position[0].toString());
        dtemp = dtemp.replace("{circleY}", cPoint.position[1].toString());
        dtemp = dtemp.replace("{dotFillColor}", cPoint.backgroundColor);
        ttempl = dtemp + ttempl;

        allTexts += ttempl;

        // toggle signum (to let x-coordinate jump from left to right of point)
        if (sig == 1) {
          //  sig = -4.3;
        } else {
          //  sig = 1;
        }
      }
    }
    // lines   --> pathColor pathWidth pathPointList pathId
    // pathPointList example: 108.97915,160.05435 -8.79317,19.08305 -10.009242,9.63506
    let allPaths: string = "";
    if (diagram.lines != undefined) {
      for (let i = 0; i < diagram.lines.length; i++) {
        let ttempl = pathTemplate;
        ttempl = ttempl.replace("{pathId}", "path-" + i);
        ttempl = ttempl.replace("{pathWidth}", diagram.lines[i].lineWidth.toString());
        ttempl = ttempl.replace("{pathColor}", diagram.lines[i].lineColor);

        let pathPointsListString: string = "";
        for (let f = 0; f < diagram.lines[i].points.length; f++) {
          try {
            pathPointsListString += diagram.lines[i].points[f][0] + "," + diagram.lines[i].points[f][1] + " ";
          } catch (err) {
            /* empty */
          }
        }

        ttempl = ttempl.replace("{pathPointList}", pathPointsListString);
        allPaths += ttempl;
      }
    }

    const outSvg: string = svgTemplate
      .replace("{backgroundImage}", diagram.image)
      .replace("{allPoints}", allTexts)
      .replace("{allLines}", allPaths)
      .replace(
        "{txtAnnu}",
        textTemplateAnnunciator.replaceAll("annunciatorFilter", filterPrefix + "annunciatorFilter")
      );

    return diagram.printLightKey
      ? outSvg.replace("<svg ", `<svg class="perf-dark-diagram perf-light-key-${diagram.printLightKey}" `)
      : outSvg;
  }

  /**
   * Scheme allowlist for the ONE value this class interpolates into an
   * attribute itself: the `;sql:` dispatcher's `<img src>`, which is built
   * AFTER `converter.makeHtml` and so is not markdown output.
   *
   * This is NOT the app's XSS control. That is `sanitizeReportHtml`
   * (`core/sanitize-report-html.ts`), DOMPurify at the trusted-HTML sink —
   * which is where every path converges, including the three surfaces that
   * build HTML without going through `convMarkdown`. A previous cut ran a
   * regex over the whole rendered document; adversarial review produced 11
   * live bypasses against it (named entities, a decoy `href="` swallowing the
   * next delimiter, unquoted attributes, every attribute that is not
   * `href`/`src`) and it corrupted `src=` inside fenced code blocks. It was
   * removed rather than patched again — a regex cannot parse HTML.
   */
  private static readonly SAFE_URL =
    /^(?:https?:|mailto:|tel:|data:image\/(?:png|jpe?g|gif|webp|svg\+xml);|[#/.?]|[^:]*$)/i;

  private neutralizeUrl(url: string): string {
    const normalized = url
      .replace(/&#(\d+);?/g, (_m, d) => String.fromCharCode(Number(d)))
      .replace(/&#x([0-9a-f]+);?/gi, (_m, h) => String.fromCharCode(parseInt(h, 16)))
      .replace(/[\u0000-\u0020\u00A0]/g, "")
      .trim();
    return markDownProcessing.SAFE_URL.test(normalized) ? url : "#";
  }

  async convMarkdown(
    mdString: string,
    appearance: appearanceEnum,
    flightId: string,
    opsMissionType: opsMissionTypeEnum,
    classCom: opsCntrolCom,
    provider?: any,
    signatureId?: string,
    // The calculation result of the report row that is shown. Its diagrams
    // draw from it.
    resultJson?: string
  ): Promise<string> {
    // handle db newlines
    mdString = mdString.replace(/<br\/>/g, "\n");

    const fpp = new fppProvider();
    const acft = await fpp.getAircraftData(classCom.aircraftRegistration, classCom);

    // singature
    const mdText_lst: string[] = [];

    // Prefer the signature THIS report row was actually computed under, read
    // through the `signatureId` frozen onto it. The designator lookup below
    // resolves whatever the ACTIVE duty points at TODAY, and re-signing moves
    // that pointer — so an already-issued report silently acquired a new
    // ops-control-cert hash on the next sign.
    //
    // Resolution is per ROW, not per flight. The flight-wide read is the
    // fallback for rows that predate the column: asking it first re-stamped a
    // fuel OFP from a newer met/notam/nav row, or from another mission type,
    // because those are written by their own triggers with their own Timestamps.
    //
    // Callers with no flight at all (the duty Crew Report) pass no flightId —
    // querying anyway threw on web, where undefined params are rejected at the
    // DbSrv boundary, and silently killed the report page.
    //
    // A row that HAS a signatureId never falls through to either of the other
    // two reads, even when the id resolves to nothing locally. It legitimately
    // can: a peer's signature does not reach an iPad yet. But the fallbacks
    // answer a different question — "what is the newest signature on this
    // flight" and "what does today's duty designator point at" — and stamping
    // this row with either is exactly the misattribution `signatureId` exists to
    // remove, now with the row's own correct answer sitting right there. An
    // unresolvable id is reported honestly as unsigned instead.
    //
    // `""` and NULL/absent are DIFFERENT answers and are branched separately.
    // `currentSignatureId` stores `""` when the flight resolved no crew at write
    // time — a positive statement that this calculation ran under NO signature —
    // while NULL means the row predates the column and its signature is unknown.
    // Both are falsy, so a single truthiness gate sent `""` into the fallbacks
    // and stamped a document that provably had no signature with today's duty
    // certificate. Reachable by calculating before signing and rendering after.
    let result: any[];

    if (signatureId === "") {
      result = [];
    } else if (signatureId) {
      result = await classCom.namedQuery("flightcrewBySignatureId", { signatureId });
    } else if (flightId) {
      result = await classCom.namedQuery("flightcrewSignatureOfFlight", { flightId });
      if (result.length === 0 && classCom.activeDutyDesig != "") {
        result = await classCom.namedQuery("flightcrewPicByDesignator", {
          crewDesignator: classCom.activeDutyDesig,
        });
      }
    } else if (classCom.activeDutyDesig != "") {
      result = await classCom.namedQuery("flightcrewPicByDesignator", {
        crewDesignator: classCom.activeDutyDesig,
      });
    } else {
      result = [];
    }

    if (result.length > 0) {
      const name: string = result[0].pilotInCommand;
      const signature: string = result[0].signature;

      const sHash: string = "13030d3b776ba930c1fcf399fb809a6dc2e2b7b6";

      const opsCtrlSign: string = classCom.package_md5(signature + "|" + sHash + "|" + mdString);

      mdText_lst.push("");
      mdText_lst.push("________________________");
      mdText_lst.push(" ");
      // mdText_lst.push("Duty OFP signed: **" + name.toUpperCase() + "** \n");
      mdText_lst.push("ops-control-cert signing: **`" + opsCtrlSign + "`** ");
    }

    for (let i = 0; i < mdText_lst.length; i++) {
      mdString += mdText_lst[i] + "\n";
    }

    try {
      const darkCss: string =
        " .perfViolation {background-color:yellow,color:black} .fillArea {width: 100 %; background-color:#303030; padding: 5px} table { margin: 10px 0 15px 0; border-collapse: collapse; } td, th { border: 1px solid #ddd; padding: 3px 10px; } th { padding: 5px 10px; background-color: #1f2022 }    hr { margin: 0 0 19px; border: 0; border-bottom: 5px solid #303030; } blockquote { padding: 13px 13px 21px 15px; margin-bottom: 18px; font-family: georgia,serif; font-style: italic; } blockquote:before { content: '\\201C'; font-size: 40px; margin-left: -10px; font-family: georgia,serif } blockquote p { font-size: 14px; font-weight: 300; line-height: 18px; margin-bottom: 0; font-style: italic; } code, pre { font-family: Menlo, Monaco, Andale Mono, Courier New, monospace; } code { padding: 1px 3px; font-size: 12px; -webkit-border-radius: 3px; -moz-border-radius: 3px; border-radius: 3px; background: #334; } pre { display: block; padding: 14px; margin: 0 0 18px; line-height: 16px; font-size: 11px; border: 1px solid #334; white-space: pre; white-space: pre-wrap; word-wrap: break-word; background-color: #282a36; border-radius: 6px; } pre code { font-size: 11px; padding: 0; background: transparent; } sup { font-size: 0.83em; vertical-align: super; line-height: 0; } * { -webkit-print-color-adjust: exact; } @media screen and (min-width: 914px) { body { margin-left: 10px auto; } } @media print { body, code, pre code, h1, h2, h3, h4, h5, h6 { color: black; } table, pre { page-break-inside: avoid; } } ";
      const lightCss: string =
        ".perfViolation {background-color:yellow,color:black} .fillArea {width: 100 %; background-color:#E8E8E8; padding: 5px} table { margin: 10px 0 15px 0; border-collapse: collapse; } td, th { border: 1px solid black; padding: 3px 10px; } th { padding: 5px 10px; color: black; background-color: whitesmoke } hr { margin: 0 0 19px; border: 0; border-bottom: 3px solid black; } blockquote { padding: 13px 13px 21px 15px; margin-bottom: 18px; font-family: georgia,serif; font-style: italic; } blockquote:before { content: '}\\201C'; font-size: 40px; margin-left: -10px; font-family: georgia,serif } blockquote p { font-size: 14px; font-weight: 300; line-height: 18px; margin-bottom: 0; font-style: italic; } code, pre { font-family: Monaco, Andale Mono, Courier New, monospace; } code { background-color: #fee9cc; color: rgba(0, 0, 0, 0.75); padding: 1px 3px; font-size: 12px; -webkit-border-radius: 3px; -moz-border-radius: 3px; border-radius: 3px; } pre { display: block; padding: 14px; margin: 0 0 18px; line-height: 16px; font-size: 11px; border: 1px solid #d9d9d9; white-space: pre-wrap; word-wrap: break-word; } pre code { background-color: #fff; color: #737373; font-size: 11px; padding: 0; } sup { font-size: 0.83em; vertical-align: super; line-height: 0; } * { -webkit-print-color-adjust: exact; } @media screen and (min-width: 914px) { body { margin-left: 10px auto; } } @media print { body, code, pre code, h1, h2, h3, h4, h5, h6 { color: black; } table, pre { page-break-inside: avoid; } } ";

      let css = lightCss;
      if (appearance == appearanceEnum.dark) {
        css = darkCss;
      } else {
        css = lightCss;
      }
      // css = lightCss
      const converter = new classCom.package_Showdown.Converter();

      const text = mdString;
      converter.setOption("tables", true);
      converter.setOption("strikethrough", true);
      converter.setOption("literalMidWordUnderscores", true);

      const html: string = converter.makeHtml(text);

      // background color change:
      const htmlRows: string[] = html.split("\n");
      for (let i = 0; i < htmlRows.length; i++) {
        const currRow: string = htmlRows[i];

        if (currRow.includes("|&gt") || currRow.includes("|>")) {
          htmlRows[i] = "<div class='fillArea'>";
        }
        if (currRow.includes("|&lt") || currRow.includes("|<")) {
          htmlRows[i] = "</div>";
        }
      }

      // image support

      let htmlIncImage: string = "";
      for (let i = 0; i < htmlRows.length; i++) {
        try {
          const currRow: string = htmlRows[i];

          const matches = currRow.match(/!\[.{0,}]\(.{0,};sql:.{0,}/g);

          if (matches != null) {
            for (let m = 0; m < matches.length; m++) {
              let sqlSmtn: string = matches[m].split("sql:")[1];
              sqlSmtn = sqlSmtn.replace(/<.{0,}>/g, "");
              // Same renderer escaping as the fppDiagr payload below: a double-quoted SQL
              // identifier would otherwise reach sqlRunCmd as &quot;. Restores what the
              // previous renderer delivered; the single quote, which is the character that
              // matters for this statement, was never escaped by either renderer.
              sqlSmtn = sqlSmtn.replace(/&quot;|&#34;/g, '"');
              const pixelWidth1: string = matches[m].split("width:")[1];
              const pixelWidth: string = pixelWidth1.split("px;sql")[0];

              // remove the closing bracket
              sqlSmtn = sqlSmtn.substring(0, sqlSmtn.length - 1);

              const base64String: string = await (
                await classCom.sqlRunCmd(
                  sqlSmtn,
                  [...AIRCRAFT_CONTROLLER_PROCESSES],
                  "ops_control_flight_perf_processor"
                )
              )[0].value;

              // Both interpolations are attacker-reachable and are built AFTER
              // makeHtml, so the output pass above never sees them. The width
              // comes straight out of the markdown, and the src is a SELECTed
              // value whose query also comes from the markdown — so a report
              // returning a `'` breaks out of the attribute. Constrain both:
              // digits for the width, a data:image URI for the src.
              // Take the LEADING digits, don't require the whole string to be
              // digits. `pixelWidth` is only `split("px;sql")`-trimmed, and the
              // one live producer writes `width:480;sql:` with no `px`
              // (`fppProvider` aircraft image) — so the tail is still attached
              // and a digits-only test rejected the only real value, silently
              // dropping the width and rendering the photo at natural size.
              // Browsers parsed `width='480;sql:…'` as 480 by the dimension
              // rules; this keeps that number and drops the injectable tail.
              const safeWidth: string = (/^\s*(\d{1,5})/.exec(pixelWidth) ?? ["", ""])[1];
              const safeSrc: string = this.neutralizeUrl(String(base64String ?? "")).replace(/['"]/g, "");

              const imghtml: string =
                "<img style='display: block;margin-left: auto;margin-right: auto;' src='" +
                safeSrc +
                "' alt='sql image' width='" +
                safeWidth +
                "'/>";
              htmlRows[i] = currRow.replace(/!\[.{0,}]\(.{0,};sql:.{0,}/g, imghtml);
            }
          }

          const matchesDiagr = currRow.match(/\[\]fppDiagr:.{0,}/g);

          if (matchesDiagr != null) {
            for (let m = 0; m < matchesDiagr.length; m++) {
              let fppDiagramObj: string = matchesDiagr[m].split("fppDiagr:")[1];
              fppDiagramObj = fppDiagramObj.replace(/<.{0,}>/g, "");
              // The Markdown renderer escapes the double quotes that JSON.stringify put
              // into the filter payload, which made JSON.parse below throw and cost the
              // whole row -- the HOGE and CAT-A diagrams -- via the catch at the end of
              // this loop. Decode only the quote, only on this directive's own substring,
              // and only after the tag strip above: decoding &lt;/&gt; first would let
              // that greedy strip eat the payload, and decoding the surrounding row would
              // put raw markup back into report prose that is trusted downstream.
              fppDiagramObj = fppDiagramObj.replace(/&quot;|&#34;/g, '"');

              const param = fppDiagramObj.split(":");

              const model = param[0];
              const perfResultType: number = Number(param[1]);

              let filterConditions: string[];
              if (param.length > 2) {
                filterConditions = JSON.parse(fppDiagramObj.split(":")[2]);
              }

              const digrData: svgDiagramDataStruct[] = await this.getPerfDiagramData(
                perfResultType,
                model,
                classCom,
                flightId,
                opsMissionType,
                provider,
                filterConditions,
                acft.perfParameters,
                resultJson
              );

              let html = "";
              for (let ss = 0; ss < digrData.length; ss++) {
                html += this.createSvgDiagram(digrData[ss]);
              }

              htmlRows[i] = currRow.replace(/\[\]fppDiagr:.{0,}/g, html);
            }
          }

          // AEO HOGE stores its charts as one line of inputs; draw them here.
          const aeoHoge = parseAeoHogeChartLine(currRow);
          if (aeoHoge) {
            const html = await renderAeoHogeCharts(
              aeoHoge.model,
              acft?.perfParameters ?? "",
              classCom,
              aeoHoge.conditions
            );
            htmlRows[i] = currRow.replace(/\[\]fppAeoHoge:.{0,}/g, html);
          }

          const svgTest = currRow.includes("<em>svgTest</em>");
          if (svgTest == true) {
            const svghtml: string = await this.createSvgDiagram(null);
            htmlRows[i] = currRow.replace("<em>svgTest</em>", svghtml);
          }

          htmlIncImage += htmlRows[i] + "\n";
        } catch (err) {
          // This catch drops the whole row, so a report section can disappear with no
          // other trace -- that is how the escaped fppDiagr payload silently removed the
          // HOGE and CAT-A diagrams. Keep the row-level recovery, but never lose the
          // reason for it.
          //
          // The row content itself is deliberately NOT logged: console breadcrumbs are
          // captured (see sentry.ts), a report row carries crew names, masses and NOTAM
          // text, and these failures are systemic -- one bad directive fails every row
          // and would evict the whole breadcrumb buffer.
          console.error("convMarkdown: dropped report row " + i + ": ", err);
        }
      }

      const cssPart: string = "<head><style>" + css + "</style></head>" + htmlIncImage;

      return cssPart;
    } catch (err) {
      /* empty */
    }
  }
  async getPerfDiagramData(
    perfResultType: perfResultsEnum,
    model: string,
    classCom: any,
    flightId: string,
    opsMissionType: opsMissionTypeEnum,
    provider: any,
    filterConditions?: string[],
    perfParameters: string = "",
    resultJson?: string
  ): Promise<svgDiagramDataStruct[]> {
    if (
      perfResultType == perfResultsEnum.withinLoadAndBalanceEnvelope_lateral ||
      perfResultType == perfResultsEnum.withinLoadAndBalanceEnvelope_longitudinal ||
      perfResultType == perfResultsEnum.hoge ||
      perfResultType == perfResultsEnum.cat_a_vtol_maxGrossMass ||
      perfResultType == perfResultsEnum.cat_a_climboutSegOne_height_over_100ft ||
      perfResultType == perfResultsEnum.maxWinchMassLimit_preloading
    ) {
      const reslt = await provider.getPerfDiagramData(
        perfResultType,
        model,
        classCom,
        flightId,
        opsMissionType,
        filterConditions,
        perfParameters,
        resultJson
      );
      return reslt;
    }

    return null;
  }
}

export function addMinutes(date, minutes): Date {
  return new Date(date.getTime() + minutes * 60000);
}

// hashing
export function getHash(value: string, length: number): string {
  if (length == undefined) {
    length = 16;
  }

  let hash = classCom.package_md5(value);
  hash = hash.replace(/a/g, "0");
  hash = hash.replace(/b/g, "1");
  hash = hash.replace(/c/g, "2");
  hash = hash.replace(/d/g, "3");
  hash = hash.replace(/e/g, "4");
  hash = hash.replace(/f/g, "5");

  if (length == 16) {
    // return (parseFloat(hash.substr(0, 16)) + parseFloat  (hash.substr(16, 16))).toString();
    return sums(hash.substr(0, 16), hash.substr(16, 16));
  } else if (length == 8) {
    return (
      parseFloat(hash.substr(0, 8)) +
      parseFloat(hash.substr(8, 8)) +
      parseFloat(hash.substr(16, 8)) +
      parseFloat(hash.substr(24, 8))
    ).toString();
  } else {
    throw {
      name: "No valid length",
      message: length.toString(),
      toString: function () {
        return this.name + ": " + this.message;
      },
    };
  }
}
function sums(arg1: string, arg2: string): string {
  let sum = "";
  let r = 0;
  let a1;
  let a2;
  let i;

  // Pick the shortest string as first parameter and the longest as second parameter in my algorithm
  if (arg1.length < arg2.length) {
    a1 = arg1;
    a2 = arg2;
  } else {
    a1 = arg2;
    a2 = arg1;
  }

  a1 = a1.split("").reverse();
  a2 = a2.split("").reverse();

  // Sum a1 and a2 digits
  for (i = 0; i < a2.length; i++) {
    const t = (i < a1.length ? parseInt(a1[i]) : 0) + parseInt(a2[i]) + r;
    sum += t % 10;
    r = t < 10 ? 0 : Math.floor(t / 10);
  }
  // Append the last remain
  if (r > 0) {
    sum += r;
  }

  const sumArr = sum.split("").reverse();

  // Trim the leading "0"
  while (sumArr[0] == "0") {
    sumArr.shift();
  }

  return sumArr.length > 0 ? sumArr.join("") : "0";
}

export function checkVectorCutNotExtrapolated(
  LineStartpt: number[],
  LineEndpt: number[],
  CheckPt: number[],
  lambdamax?: number
): boolean {
  if (lambdamax == undefined) {
    lambdamax = 1;
  }

  const xx = LineEndpt[0] - LineStartpt[0];
  const xy = LineEndpt[1] - LineStartpt[1];

  const p0y = LineStartpt[1];
  const p0x = LineStartpt[0];

  const c0x = CheckPt[0];
  const c0y = CheckPt[1];

  const lambda: number = (1 / (xx * xx + xy * xy)) * (-xy * p0y + c0y * xy - (p0x - c0x) * xx);
  return lambda > 0 && lambda < lambdamax;
}

export function checkPointIsRouteRelevant(
  LineStartpt: number[],
  LineEndpt: number[],
  checkPt: number[],
  allowExtrapolation: boolean,
  stepInterval?: number
): { trackDist: number; distFromRoute: number } {
  // check extrapolation
  if (!allowExtrapolation) {
    if (checkVectorCutNotExtrapolated(LineStartpt, LineEndpt, checkPt) == false) {
      return { trackDist: 0, distFromRoute: 9999999 };
    }
  }

  const Dist: number = getDistance(LineStartpt, LineEndpt);
  const brg: number = getBearing(LineStartpt, LineEndpt);

  let interval: number = 5;

  if (stepInterval !== undefined) {
    interval = stepInterval;
  }
  // iterate all 1000 meters to hack the earth curveture
  const nbrOfItSteps: number = Math.round(Dist / interval) + 1;

  let smallestDistFromRoute: number = 0;
  let trackDistanceAt: number = 0;

  for (let it = 1; it < nbrOfItSteps + 1; it++) {
    const distIntoRoute: number = it * interval;

    const pointOnRoute = getRadialCoordinates(LineStartpt, brg, distIntoRoute);

    const trackDist: number = distIntoRoute * 1852; // in meters
    const distFromRoute: number = getDistance(pointOnRoute, checkPt);

    if (smallestDistFromRoute > distFromRoute || smallestDistFromRoute == 0) {
      smallestDistFromRoute = distFromRoute;
      trackDistanceAt = trackDist;
    }
  }

  return { trackDist: trackDistanceAt, distFromRoute: smallestDistFromRoute };

  // old code from here

  // let z = new vectorStruct()
  // z.x = checkPt[0] - LineStartpt[0]
  // z.y = checkPt[1] - LineStartpt[1]

  // let a = new vectorStruct()
  // a.x = LineEndpt[0] - LineStartpt[0]
  // a.y = LineEndpt[1] - LineStartpt[1]

  // let CrossProd = new vectorStruct
  // CrossProd.x = z.x * a.y - z.y * a.x
  // CrossProd.y =0
  // let AbsCrossProd: number = Math.sqrt(Math.pow(CrossProd.x,2) + Math.pow(CrossProd.y, 2))
  // let AbsA: number = Math.sqrt(Math.pow(a.x,2) + Math.pow(a.y,2))

  // if (AbsA == 0) { AbsA = 0.0000000001 }
  // let Dist: number = (AbsCrossProd / AbsA) * 60 * 1852
  // if (Dist == 0) { Dist = 9999 }

  // // =========== so far the distance ==========

  // // next the length from point 0 -> which is a pytagoras
  // let vecP0ToCheckP: number[] = []

  // vecP0ToCheckP[0] = (LineStartpt[0] - checkPt[0]) * 60 * 1852
  // vecP0ToCheckP[1] = (LineStartpt[1] - checkPt[1]) * 60 * 1852

  // let dist_P0ToCheckP: number = Math.sqrt(Math.pow(vecP0ToCheckP[0],2) + Math.pow(vecP0ToCheckP[1],2))

  // let distFromPoToCrossingPoint: number = Math.sqrt(Math.pow(dist_P0ToCheckP, 2) + Math.pow(Dist, 2)) /( 60 * 1852)

  // let p0_p1: number[] = []
  // p0_p1[0] = LineEndpt[0] - LineStartpt[0]
  // p0_p1[1] = LineEndpt[1] - LineStartpt[1]

  // let distFromP1ToP2 = Math.sqrt(Math.pow(p0_p1[0],2) + Math.pow(p0_p1[1],2))

  // // norm vector
  // let nV: number[] = []
  // nV[0] = p0_p1[0] / distFromP1ToP2
  // nV[1] = p0_p1[1] / distFromP1ToP2

  // let CrossingPoint: number[] = []
  // CrossingPoint[0] = LineStartpt[0] + nV[0] * distFromPoToCrossingPoint
  // CrossingPoint[1] = LineStartpt[1] + nV[1] * distFromPoToCrossingPoint

  // // calc geo distance
  // let trackDist: number = getDistance(CrossingPoint, LineStartpt)
  // let distFromRoute: number = getDistance(CrossingPoint, checkPt)

  // // calc distance to one of both points the handle edge cases
  // let distP1 : number =   getDistance(checkPt, LineStartpt)
  // let distP2: number = getDistance(checkPt, LineEndpt)

  // if (distP1 < distFromRoute) { distFromRoute = distP1 }
  // if (distP2 < distFromRoute) { distFromRoute = distP2 }

  // return { trackDist: trackDist, distFromRoute: distFromRoute}
}

const earthRadius: number = 3440.0652187;
export function getRadialCoordinates(centerPoint: number[], angle: number, distance: number) {
  const coordinates: number[] = [];

  const height = 0;

  if (distance == 0) {
    coordinates[1] = centerPoint[1];
    coordinates[0] = centerPoint[0];
    return coordinates;
  } else if (distance < 0) {
    distance *= -1;
    angle += 180;
  }

  let westHemisphere = 1;

  while (angle < 0) {
    angle += 360;
  }

  while (angle > 360) {
    angle -= 360;
  }

  if (angle > 180) {
    westHemisphere = -1;
  }

  const cosTheta = Math.cos(distance / (earthRadius + height));
  const cosA = Math.cos((centerPoint[1] * Math.PI) / 180);
  const cosAlpha = Math.cos((angle * Math.PI) / 180);

  const sinTheta = Math.sin(distance / (earthRadius + height));
  const sinA = Math.sin((centerPoint[1] * Math.PI) / 180);

  coordinates[1] = (Math.asin(cosAlpha * cosA * sinTheta + sinA * cosTheta) * 180) / Math.PI;

  let n = Math.sqrt(1 - Math.pow(cosAlpha * cosA * sinTheta + cosTheta * sinA, 2));
  const z = cosTheta * cosA - cosAlpha * sinTheta * sinA;

  if (z > n) {
    n = z;
  }
  coordinates[0] = centerPoint[0] + ((Math.acos(z / n) * 180) / Math.PI) * westHemisphere;

  return coordinates;
}

export function getDistance(startPoint: number[], endPoint: number[]): number {
  if (startPoint[1] == endPoint[1] && startPoint[0] == endPoint[0]) {
    return 0;
  }

  const V1x = earthRadius * (Math.cos((startPoint[1] * Math.PI) / 180) * Math.cos((startPoint[0] * Math.PI) / 180));
  const V1y = earthRadius * (Math.cos((startPoint[1] * Math.PI) / 180) * Math.sin((startPoint[0] * Math.PI) / 180));
  const V1z = earthRadius * Math.sin((startPoint[1] * Math.PI) / 180);

  const V2x = earthRadius * (Math.cos((endPoint[1] * Math.PI) / 180) * Math.cos((endPoint[0] * Math.PI) / 180));
  const V2y = earthRadius * (Math.cos((endPoint[1] * Math.PI) / 180) * Math.sin((endPoint[0] * Math.PI) / 180));
  const V2z = earthRadius * Math.sin((endPoint[1] * Math.PI) / 180);

  let value =
    (V1x * V2x + V1y * V2y + V1z * V2z) /
    (Math.sqrt(Math.pow(V1x, 2) + Math.pow(V1y, 2) + Math.pow(V1z, 2)) *
      Math.sqrt(Math.pow(V2x, 2) + Math.pow(V2y, 2) + Math.pow(V2z, 2)));
  if (value > 1) {
    value = 1;
  } else if (value < -1) {
    value = -1;
  }

  return Math.acos(value) * earthRadius;
}

export function getBearing(centerPoint: number[], directionPoint: number[]): number {
  if (centerPoint[1] == directionPoint[1] && centerPoint[0] == directionPoint[0]) {
    return 0;
  }

  const cos_phiA = Math.cos((centerPoint[1] * Math.PI) / 180);
  const cos_phiB = Math.cos((directionPoint[1] * Math.PI) / 180);
  const sin_phiA = Math.sin((centerPoint[1] * Math.PI) / 180);
  const sin_phiB = Math.sin((directionPoint[1] * Math.PI) / 180);
  const cos_lambdaLamdaB = Math.cos(((centerPoint[0] - directionPoint[0]) * Math.PI) / 180);

  let n = Math.sqrt(1 - Math.pow(cos_lambdaLamdaB * cos_phiA * cos_phiB + sin_phiA * sin_phiB, 2));
  let z = cos_phiA * sin_phiB - cos_lambdaLamdaB * cos_phiB * sin_phiA;

  let zTemp = 0;
  if (Math.abs(n) < Math.abs(z)) {
    zTemp = z;
    z = n;
    n = zTemp;
  }

  const val = (Math.acos(z / n) * 180) / Math.PI;

  if (centerPoint[0] > directionPoint[0]) {
    return val * -1;
  } else {
    return val;
  }
}

export function round(val: number, digits: number): number {
  return Math.round(val * Math.pow(10, digits)) / Math.pow(10, digits);
}

export function translateToFplCoordinates(instr): string {
  const cArr = JSON.parse(instr);

  const longitude: number = parseFloat(cArr[0]);
  let HemEW = "E";

  if (longitude < 0) HemEW = "W";

  const degrees_lon: number = Math.floor(longitude);
  const minutes_lon: number = Math.round((longitude - degrees_lon) * 60);

  const latitude: number = parseFloat(cArr[1]);
  let HemNS = "N";

  if (latitude < 0) HemNS = "S";

  const degrees_lat: number = Math.floor(latitude);
  const minutes_lat: number = Math.round((latitude - degrees_lat) * 60);

  // 4733N00958E

  const value =
    pad(degrees_lat, 2).toString() +
    pad(minutes_lat, 2).toString() +
    HemNS +
    pad(degrees_lon, 3).toString() +
    pad(minutes_lon, 2).toString() +
    HemEW;

  return value.toString();
}

export function pad(num, size) {
  num = num.toString();
  while (num.length < size) num = "0" + num;
  return num;
}

export function calcPressureAltitude(elevation: number, qnh_pa: number): number {
  let pa: number = elevation + 145442.2 * (1 - Math.pow(qnh_pa / 101320, 0.19261));

  if (pa < 0) {
    pa = 0;
  }

  return pa;
}

export function kelvin2centigrade(kelvin: number): number {
  return round(kelvin - 273.15, 0);
}
export function meters2feet(meters: number): number {
  return round(meters * 3.28084, 0);
}

export function pascal2mbar(pascal: number): number {
  return round(pascal / 100, 0);
}
export function centigrade2kelvin(centigrade: number): number {
  return round(centigrade + 273.15, 0);
}
export function feet2meters(feet: number): number {
  return round(feet / 3.28084, 0);
}

export function mbar2pascal(mbar: number): number {
  return round(mbar * 100, 0);
}

// required for sorting alphabetical numeric
export function dynamicSort(property, sortOrder: number = -1) {
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}
export function checkArgLength(fnName: string, actualLen: number, expectedLen: number | number[]): boolean {
  const expectArray = Array.isArray(expectedLen) ? expectedLen : [expectedLen];
  const match = expectArray.includes(actualLen);

  if (!match) {
    const fxSig = availFx.find((sig) => sig.startsWith(fnName + "("));
    const sigMsg = fxSig ? `Full Signature:\n│   \x1b[36m${fxSig}\x1b[0m` : "No signature found.";

    console.log("╭──────────────────────────────────────────────────────────╮");
    console.log(`│ ⚠️  Argument Mismatch for \x1b[33m${fnName}\x1b[0m`);
    console.log("├──────────────────────────────────────────────────────────┤");
    console.log(`│ Expected : \x1b[32m${expectArray.join(" or ")}\x1b[0m`);
    console.log(`│ Received : \x1b[31m${actualLen}\x1b[0m`);
    console.log("│");
    console.log(`│ ${sigMsg.split("\n").join("\n│ ")}`); // align multi-line sig
    console.log("╰──────────────────────────────────────────────────────────╯");

    return false;
  }
  return true;
}

export function alignMarkdownTablesInDocument(document: string): string {
  const lines = document.split("\n");
  const resultLines: string[] = [];
  let tableBuffer: string[] = [];
  let insideTable = false;

  const isTableLine = (line: string) => line.trim().startsWith("|") && line.includes("|");
  const isSeparator = (row: string[]) => row.every((cell) => /^:?-{3,}:?$/.test(cell));

  const flushTable = () => {
    if (tableBuffer.length < 2) {
      resultLines.push(...tableBuffer);
      tableBuffer = [];
      return;
    }

    // Parse and normalize rows
    const parsedRows = tableBuffer.map((line) =>
      line
        .split("|")
        .slice(1, -1)
        .map((cell) => cell.trim())
    );

    // Remove artifacts like rows full of dashes or headers mistakenly parsed as rows
    const rows = parsedRows.filter((row) => !isSeparator(row) && !(row.length === 1 && /^-+$/.test(row[0])));

    const colCount = Math.max(...rows.map((row) => row.length));
    rows.forEach((row) => {
      while (row.length < colCount) row.push("");
    });

    const colWidths = Array(colCount).fill(0);
    rows.forEach((row) => {
      row.forEach((cell, i) => {
        colWidths[i] = Math.max(colWidths[i], cell.length);
      });
    });

    const formatRow = (row: string[]): string =>
      "| " + row.map((cell, i) => cell.padEnd(colWidths[i])).join(" | ") + " |";

    const separatorRow = "| " + colWidths.map((w) => "-".repeat(w)).join(" | ") + " |";

    resultLines.push(formatRow(rows[0]));
    resultLines.push(separatorRow);
    rows.slice(1).forEach((row) => resultLines.push(formatRow(row)));
    tableBuffer = [];
  };

  for (const line of lines) {
    if (isTableLine(line)) {
      tableBuffer.push(line);
      insideTable = true;
    } else {
      if (insideTable) {
        flushTable();
        insideTable = false;
      }
      resultLines.push(line);
    }
  }
  if (insideTable) flushTable();

  console.log(resultLines.join("\n"));

  return resultLines.join("\n");
}
